import { useEffect, useState } from 'react';

export function QRIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#2A3547"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 17v.01M7 7v.01M17 7v.01M17 14h-3v3m6-3v.01M14 20h3m0-3h3v3M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4z"
      ></path>
    </svg>
  );
}

export function DownloadIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-download"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
      <path d="M7 11l5 5l5 -5" />
      <path d="M12 4l0 12" />
    </svg>
  );
}

export function LetterIco({ color = '#5D87FF', strokeWidth = 2.667 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M20 5.334h1.333a1.333 1.333 0 011.334 1.333v4.667m4-3.333c.351.149.693.289 1.023.42a1.333 1.333 0 01.707 1.748l-3.064 7.165M4.805 9.597l9.518-4.146a1.28 1.28 0 011.693.703l6.565 15.87a1.334 1.334 0 01-.685 1.738l-9.516 4.145a1.28 1.28 0 01-1.695-.702L4.12 11.334a1.333 1.333 0 01.685-1.737z"
      ></path>
    </svg>
  );
}

export function GalleryIco({ color = '#5D87FF', strokeWidth = 2.667 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" fill="none" viewBox="0 0 33 32">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M12.5 20.002h-4a4 4 0 01-4-4v-8a4 4 0 014-4h8a4 4 0 014 4v4"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M4.5 16.002l3.061-3.061a3.213 3.213 0 014.544 0l.395.395m0 2.666a4 4 0 014-4h8a4 4 0 014 4v8a4 4 0 01-4 4h-8a4 4 0 01-4-4v-8z"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M9.834 8.002v.013m9.333 9.987v4l3.333-2-3.333-2z"
      ></path>
    </svg>
  );
}

export function EditIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-user-edit"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
      <path d="M6 21v-2a4 4 0 0 1 4 -4h3.5" />
      <path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z" />
    </svg>
  );
}

export function ExpandIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#5D87FF"
        d="M8 15.996a8 8 0 1116 0 8 8 0 01-16 0zm8-5a5 5 0 100 10 5 5 0 000-10z"
      ></path>
    </svg>
  );
}

export function CollapseIco() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15.9961C8 13.8744 8.84285 11.8395 10.3431 10.3392C11.8434 8.83895 13.8783 7.99609 16 7.99609C18.1217 7.99609 20.1566 8.83895 21.6569 10.3392C23.1571 11.8395 24 13.8744 24 15.9961C24 18.1178 23.1571 20.1527 21.6569 21.6529C20.1566 23.1532 18.1217 23.9961 16 23.9961C13.8783 23.9961 11.8434 23.1532 10.3431 21.6529C8.84285 20.1527 8 18.1178 8 15.9961ZM16 10.9961C14.6739 10.9961 13.4021 11.5229 12.4645 12.4606C11.5268 13.3982 11 14.67 11 15.9961C11 17.3222 11.5268 18.5939 12.4645 19.5316C13.4021 20.4693 14.6739 20.9961 16 20.9961C17.3261 20.9961 18.5979 20.4693 19.5355 19.5316C20.4732 18.5939 21 17.3222 21 15.9961C21 14.67 20.4732 13.3982 19.5355 12.4606C18.5979 11.5229 17.3261 10.9961 16 10.9961Z"
        fill="#E8F7FF"
      />
    </svg>
  );
}

export function ThiepMoiIco() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-id-badge-2"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M7 12h3v4h-3z"></path>
      <path d="M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6"></path>
      <path d="M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"></path>
      <path d="M14 16h2"></path>
      <path d="M14 12h4"></path>
    </svg>
  );
}

export function Pictureeco() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-photo"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M15 8h.01"></path>
      <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z"></path>
      <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5"></path>
      <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3"></path>
    </svg>
  );
}

export function SaveContactPl() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-user-scan"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10 9a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
      <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />
      <path d="M4 16v2a2 2 0 0 0 2 2h2" />
      <path d="M16 4h2a2 2 0 0 1 2 2v2" />
      <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
      <path d="M8 16a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2" />
    </svg>
  );
}

export function TransferPayments() {
  return (
    <svg
      enable-background="new 0 0 68 68"
      height="32"
      viewBox="0 0 68 68"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
      style={{ paddingRight: '10px' }}
    >
      <g id="_x35_">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m63.5814896 36.2649384-41.2045212 22.6769828c-2.2589283 1.243206-5.0979729.4197998-6.3411808-1.8391342l-12.5565136-22.8154182c-1.2432075-2.258934-.4198017-5.0979767 1.8391283-6.3411827l41.2045212-22.676981c2.2589302-1.243206 5.0979729-.4197984 6.3411789 1.8391328l12.5565147 22.8154221c1.2432089 2.2589297.4197989 5.0979723-1.8391275 6.3411784z"
                  fill="#febc1f"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m62.6815987 34.6298218-41.2045212 22.676979c-2.2589283 1.243206-5.0979729.4197998-6.3411798-1.8391304l-12.5565146-22.815422c-1.2432075-2.2589302-.4198017-5.0979748 1.8391283-6.3411808l41.2045212-22.676981c2.2589302-1.2432063 5.0979729-.4197984 6.3411789 1.839133l12.5565176 22.8154214c1.2432022 2.2589302.4197998 5.0979748-1.8391304 6.3411808z"
                  fill="#ffd475"
                />
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="m45.6230049 3.6340563-41.2044864 22.6770265c-2.2589364 1.2432098-3.0823236 4.0822697-1.839144 6.3411503l12.556531 22.8154602s-11.7001696-22.3759117 34.6528778-51.9958496c-1.2919114-.5804889-2.829345-.5732968-4.1657784.1622126z"
                    fill="#febc1f"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m6.2700973 35.4500999 1.5767589 2.8649979c.3974571.722187 1.3051071.9854317 2.0272923.5879745l43.4678116-23.9225845c.722187-.3974562.9854317-1.3051062.5879745-2.0272932l-1.5767593-2.8649998c-.3974563-.722187-1.3051063-.9854326-2.0272933-.5879764l-43.4678107 23.9225874c-.7221856.3974571-.9854307 1.3051071-.587974 2.0272941z"
                  fill="#1d2943"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m5.8331218 34.656105 1.5767584 2.8650017c.3974571.7221832 1.3051066.9854317 2.0272927.5879745l43.4678116-23.9225883c.722187-.3974562.9854317-1.3051062.5879745-2.0272923l-1.5767593-2.8649998c-.3974571-.722187-1.3051071-.9854326-2.0272903-.5879765l-43.4678136 23.9225866c-.722186.3974571-.9854311 1.3051071-.587974 2.0272941z"
                  fill="#4c5c75"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <path
                d="m56.1312866 64.9452744-47.0325269.0000228c-2.5784349 0-4.6686702-2.0902367-4.6686711-4.6686707l-.0000087-26.0424384c-.000001-2.578434 2.0902333-4.6686687 4.6686683-4.6686687l47.0325279-.0000191c2.578434 0 4.6686707 2.0902328 4.6686707 4.6686687l.0000076 26.0424385c-.0000009 2.578434-2.0902338 4.6686669-4.6686678 4.6686669z"
                fill="#5094ff"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="m9.0987463 63.0788879 47.0325241.0000191c2.5784378 0 4.6686707-2.0902367 4.6686745-4.6686707l.0000076-26.0424347c0-2.5784359-2.0902328-4.6686726-4.6686668-4.6686726l-47.032528-.000019c-2.5784345 0-4.6686697 2.0902328-4.6686707 4.6686687l-.0000085 26.0424386c-.0000009 2.578434 2.0902329 4.6686706 4.6686678 4.6686706z"
                fill="#57b3fe"
              />
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m9.0987663 27.6990719 47.0325203.0000744c2.5784416 0 4.6686668 2.0902576 4.6686668 4.6686363l-.0000038 26.0424805s-.538311-25.2444992-55.4289742-28.8447552c.8519402-1.1314583 2.2023293-1.866436 3.7277909-1.866436z"
                  fill="#5094ff"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m57.1417618 54.6996574v.7245789h-.0096512c.0188637.9798889-.7984848 1.8029976-1.7838097 1.8029976l-4.7369461.0000038c-.9678459 0-1.8029671-.8079567-1.7838097-1.8029976h-.0096511v-.7245789h.1157036c.2796631-.7038727 1.0414467-1.1859894 1.8416023-1.1859894l4.4091377-.0000038c.8002701 0 1.5620537.4821167 1.8417206 1.1859894z"
                    fill="#e3e7f0"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="m55.3433418 56.50811-4.5790215.0000687c-.9225769.0000114-1.7944107-.6264191-1.9239235-1.5398598-.1577072-1.1123047.7025833-2.0666733 1.7845535-2.0666847l4.5610123-.0000687c.9783401-.0000153 1.889431.709938 1.9490089 1.6864586.0661317 1.0839882-.7909735 1.9200745-1.7916297 1.9200859z"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="m43.5652237 54.6996613v.7245827h-.0096512c.0188637.9798851-.7984848 1.8029938-1.7838097 1.8029938l-4.7369461.0000038c-.9678459 0-1.8029671-.8079567-1.7838097-1.8029938h-.0096512v-.7245827h.1157036c.2796631-.7038727 1.0414467-1.1859894 1.8416023-1.1859894l4.4091377-.0000038c.8002701 0 1.5620537.4821167 1.8417206 1.1859894z"
                    fill="#e3e7f0"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="m41.7668037 56.5081139-4.5790253.0000687c-.9225769.0000153-1.7944069-.6264191-1.9239197-1.5398598-.1577072-1.1123009.7025833-2.0666695 1.7845535-2.0666809l4.5610123-.0000725c.9783363-.0000114 1.889431.7099419 1.9490089 1.6864624.0661317 1.0839843-.7909735 1.9200706-1.7916297 1.9200821z"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="m29.9886837 54.6996689v.7245789h-.0096512c.0188656.9798851-.7984829 1.8029976-1.7838097 1.8029976h-4.7369442c-.9678478 0-1.8029671-.8079529-1.7838097-1.8029938h-.0096531v-.7245827h.1157036c.279665-.7038689 1.0414486-1.1859894 1.8416023-1.1859894h4.4091377c.800272 0 1.5620556.4821167 1.8417206 1.1859894z"
                    fill="#e3e7f0"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="m28.1902657 56.5081177-4.5790234.0000725c-.9225769.0000114-1.7944088-.6264191-1.9239197-1.5398598-.1577091-1.1123047.7025814-2.0666733 1.7845497-2.0666847l4.5610161-.0000687c.9783363-.0000153 1.8894291.709938 1.9490051 1.6864586.0661316 1.0839844-.7909717 1.9200744-1.7916278 1.9200821z"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="m16.4121456 54.6996727v.7245827h-.0096512c.0188656.9798851-.7984838 1.8029938-1.7838097 1.8029938l-4.7369441.0000038c-.9678478 0-1.802968-.8079567-1.7838106-1.8029976h-.0096522v-.7245789h.1157036c.279665-.7038727 1.0414476-1.1859894 1.8416023-1.1859894l4.4091377-.0000038c.800272 0 1.5620556.4821167 1.8417206 1.1859894z"
                    fill="#e3e7f0"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="m14.6137276 56.5081253-4.5790243.0000687c-.9225769.0000114-1.7944078-.6264191-1.9239197-1.5398598-.1577077-1.1123009.7025814-2.0666733 1.7845497-2.0666847l4.5610161-.0000687c.9783363-.0000153 1.88943.709938 1.9490061 1.6864586.0661315 1.0839882-.7909708 1.9200745-1.7916279 1.9200859z"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m8.0920725 35.925663.0000019 4.3564262c0 1.0981369.890214 1.9883499 1.988348 1.9883461l8.1573095-.0000229c1.098135 0 1.988348-.890213 1.988348-1.9883461l-.0000019-4.3564301c0-1.0981331-.8902149-1.9883461-1.988348-1.9883461l-8.1573105.0000229c-1.098134.0000039-1.988347.8902169-1.988347 1.98835z"
                  fill="#febc1f"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="m8.0920725 35.2468109.000001 4.3564262c.000001 1.0981331.890214 1.9883461 1.988348 1.9883461l8.1573105-.0000229c1.0981331 0 1.988348-.8902168 1.9883461-1.9883499v-4.3564262c-.0000019-1.0981331-.8902149-1.9883461-1.988348-1.9883461l-8.1573114.0000229c-1.0981342 0-1.9883472.890213-1.9883462 1.9883499z"
                  fill="#ffd475"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m13.9477558 36.954998v-3.6965523h-.9444408v3.6965523h-4.9112435v.9444428h2.6869421v3.6921043h.9444418v-3.6921043h4.2524815v3.6921043h.9444065v-3.6921043h3.305748v-.9444428z"
                  fill="#febc1f"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m56.2796402 40.2164574-5.3172913.0000305c-.443058.0000076-.8617401-.300827-.9239388-.7394943-.075737-.5341682.3374062-.9924927.8570061-.9924965l5.3086472-.0000343c.4698334-.0000076.9073715.3409386.9359818.8098984.0317611.5205688-.3798523.9220885-.860405.9220962z"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path
                    d="m56.2796402 36.5089836-9.3353691.0000343c-.4430542.0000038-.8617401-.3008308-.9239349-.7394981-.075737-.5341682.3374023-.9924927.8570061-.9924965l9.3267212-.0000343c.4698334-.0000076.9073715.3409386.9359818.8099022.031761.5205688-.3798524.9220886-.8604051.9220924z"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m54.8607178 16.3203678c2.2225723 2.8520584 4.0391045 5.9515629 5.4309731 9.2891464-2.225937-2.8498039-4.0357934-5.9533443-5.4309731-9.2891464z"
              fill="#fff"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m13.4443359 25.6074772c3.2388935-2.4783745 6.7269783-4.5519123 10.456749-6.2024593-3.2368565 2.4816837-6.7289753 4.5484409-10.456749 6.2024593z"
              fill="#fff"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="m40.1918945 60.7349167c4.0498962-.4790192 8.107563-.4831581 12.1573486.0000458-4.0497855.4831161-8.1074485.4792175-12.1573486-.0000458z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PictureIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-photo"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M15 8h.01" />
      <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z" />
      <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5" />
      <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3" />
    </svg>
  );
}

export function AppsIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-apps"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
      <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
      <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
      <path d="M14 7l6 0" />
      <path d="M17 4l0 6" />
    </svg>
  );
}

export function CardIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-id"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z" />
      <path d="M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M15 8l2 0" />
      <path d="M15 12l2 0" />
      <path d="M7 16l10 0" />
    </svg>
  );
}

export function UserScanIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-user-scan"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10 9a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
      <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />
      <path d="M4 16v2a2 2 0 0 0 2 2h2" />
      <path d="M16 4h2a2 2 0 0 1 2 2v2" />
      <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
      <path d="M8 16a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2" />
    </svg>
  );
}

export function CalendarIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-calendar-clock"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3" />
      <path d="M16 3v4" />
      <path d="M8 3v4" />
      <path d="M4 11h10" />
      <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
      <path d="M18 16.5v1.5l.5 .5" />
    </svg>
  );
}

export function InfinityIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-infinity"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828" />
    </svg>
  );
}

export function FaceIdIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-face-id"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />
      <path d="M4 16v2a2 2 0 0 0 2 2h2" />
      <path d="M16 4h2a2 2 0 0 1 2 2v2" />
      <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
      <path d="M9 10l.01 0" />
      <path d="M15 10l.01 0" />
      <path d="M9.5 15a3.5 3.5 0 0 0 5 0" />
    </svg>
  );
}

export function GridColumn2Ico({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-columns-2"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm9 -1v18" />
    </svg>
  );
}

export function GridColumn3Ico({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-columns-3"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm6 -1v18m6 -18v18" />
    </svg>
  );
}

export function GridColumn4Ico({ width = 24, height = 24, style, color = '#5d87ff' }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      style={{ enableBackground: 'new 0 0 24 24', ...style }}
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: `\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:${color};stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n`,
        }}
      />
      <path className="st0" d="M0,0h24v24H0V0z" />
      <path
        className="st1"
        d="M3,4c0-0.6,0.4-1,1-1h16c0.6,0,1,0.4,1,1v16c0,0.6-0.4,1-1,1H4c-0.6,0-1-0.4-1-1V4z M7.6,3v18 M16.6,3v18"
      />
      <line className="st1" x1="12.2" y1={4} x2="12.2" y2={21} />
    </svg>
  );
}

export function InfoIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-info-circle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path d="M12 9h.01" />
      <path d="M11 12h1v4h1" />
    </svg>
  );
}

export function HelpIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-help-circle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z" />
    </svg>
  );
}

export function InfoFillIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-info-circle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" />
    </svg>
  );
}

export function BellRingingIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-bell-ringing"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
      <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
      <path d="M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727" />
      <path d="M3 6.727a11.05 11.05 0 0 1 2.792 -3.727" />
    </svg>
  );
}

export function AlertIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-alert-circle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" />
    </svg>
  );
}

export function NextIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9 6l6 6l-6 6" />
    </svg>
  );
}

export function PrevIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M15 6l-6 6l6 6" />
    </svg>
  );
}

export function UserNoteBookIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-address-book"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z" />
      <path d="M10 16h6" />
      <path d="M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M4 8h3" />
      <path d="M4 12h3" />
      <path d="M4 16h3" />
    </svg>
  );
}

export function MapPinIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-map-pin"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
      <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
    </svg>
  );
}

export function ClockIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-clock"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path d="M12 7v5l3 3" />
    </svg>
  );
}

export function RefreshIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-refresh"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
      <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
    </svg>
  );
}

export function ShareIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-external-link"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
      <path d="M11 13l9 -9" />
      <path d="M15 4h5v5" />
    </svg>
  );
}

export function DiscountIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-rosette-discount"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9 15l6 -6" />
      <circle cx="9.5" cy="9.5" r=".5" fill="currentColor" />
      <circle cx="14.5" cy="14.5" r=".5" fill="currentColor" />
      <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
    </svg>
  );
}

export function BroomIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#5c86fe"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
    >
      <g id="_01_align_center" data-name="01 align center">
        <path d="M18.965,8.464l5.029-5.029L22.565,2.006,17.519,7.051,15.313,4.895a2.011,2.011,0,0,0-2.724-.073A19.71,19.71,0,0,1,6.226,8.687L-.006,10.514v.756A12.892,12.892,0,0,0,13.006,24.006h1.241l.261-.182a14.98,14.98,0,0,0,6.886-12.081,2.013,2.013,0,0,0-.611-1.5ZM13.9,6.34l5.477,5.341a12.652,12.652,0,0,1-.456,3.015L11.941,7.9A24.691,24.691,0,0,0,13.9,6.34Zm-.294,15.645h-.6a11.153,11.153,0,0,1-4.293-.859,11.55,11.55,0,0,0,4.348-3.8l.518-.76L11.91,15.43l-.518.761A9.539,9.539,0,0,1,7.8,19.324l-1.229.618a10.9,10.9,0,0,1-2.585-2.563,11.632,11.632,0,0,0,4.357-2.657L6.932,13.277a9.611,9.611,0,0,1-3.974,2.317,10.4,10.4,0,0,1-.921-3.575l4.755-1.394a15.234,15.234,0,0,0,3.423-1.59l7.911,7.7A14.1,14.1,0,0,1,13.608,21.985Z" />
      </g>
    </svg>
  );
}

export function EyeIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-eye"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
      <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
    </svg>
  );
}

export function LiveIco({ width = 24, height = 24, style }) {
  const [currentDisplay, setCurrentDisplay] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDisplay((prevDisplay) => (prevDisplay === 0 ? 1 : 0));
    }, 350);

    return () => clearInterval(interval);
  }, []);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      width={width}
      height={height}
      preserveAspectRatio="xMidYMid meet"
      style={{
        transform: 'translate3d(0px, 0px, 0px)',
        contentVisibility: 'visible',
        ...style,
      }}
    >
      <defs>
        <clipPath id="__lottie_element_2">
          <rect width={512} height={512} x={0} y={0} />
        </clipPath>
      </defs>
      <g clipPath="url(#__lottie_element_2)">
        <g
          transform="matrix(1.100000023841858,0,0,1.100000023841858,251.1999969482422,256)"
          opacity={1}
          style={{ display: 'block' }}
        >
          <g opacity={1} transform="matrix(1,0,0,1,48,0)">
            <path
              fill="rgb(252,16,36)"
              fillOpacity={1}
              d=" M150,-37 C150,-37 150,37 150,37 C150,45.278499603271484 143.27850341796875,52 135,52 C135,52 -135,52 -135,52 C-143.27850341796875,52 -150,45.278499603271484 -150,37 C-150,37 -150,-37 -150,-37 C-150,-45.278499603271484 -143.27850341796875,-52 -135,-52 C-135,-52 135,-52 135,-52 C143.27850341796875,-52 150,-45.278499603271484 150,-37z"
            />
          </g>
        </g>
        <g
          transform="matrix(3.299999952316284,0,0,3.299999952316284,177.70010375976562,299.36199951171875)"
          opacity={1}
          style={{ display: 'block' }}
        >
          <g opacity={1} transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(255,255,255)"
              fillOpacity={1}
              d=" M78.04900360107422,-4.9019999504089355 C78.04900360107422,-4.9019999504089355 63.80099868774414,-4.9019999504089355 63.80099868774414,-4.9019999504089355 C63.80099868774414,-4.9019999504089355 63.80099868774414,-10.859000205993652 63.80099868774414,-10.859000205993652 C63.80099868774414,-10.859000205993652 77.54199981689453,-10.859000205993652 77.54199981689453,-10.859000205993652 C77.54199981689453,-10.859000205993652 77.54199981689453,-15.496999740600586 77.54199981689453,-15.496999740600586 C77.54199981689453,-15.496999740600586 63.80099868774414,-15.496999740600586 63.80099868774414,-15.496999740600586 C63.80099868774414,-15.496999740600586 63.80099868774414,-21.566999435424805 63.80099868774414,-21.566999435424805 C63.80099868774414,-21.566999435424805 78.04900360107422,-21.566999435424805 78.04900360107422,-21.566999435424805 C78.04900360107422,-21.566999435424805 78.04900360107422,-26.393999099731445 78.04900360107422,-26.393999099731445 C78.04900360107422,-26.393999099731445 59.051998138427734,-26.393999099731445 59.051998138427734,-26.393999099731445 C59.051998138427734,-17.608999252319336 59.051998138427734,-8.78499984741211 59.051998138427734,0 C59.051998138427734,0 78.04900360107422,0 78.04900360107422,0 C78.04900360107422,0 78.04900360107422,-4.9019999504089355 78.04900360107422,-4.9019999504089355z"
            />
          </g>
          <g opacity={1} transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(255,255,255)"
              fillOpacity={1}
              d=" M56.37900161743164,-26.393999099731445 C56.37900161743164,-26.393999099731445 51.01300048828125,-26.393999099731445 51.01300048828125,-26.393999099731445 C51.01300048828125,-26.393999099731445 43.32699966430664,-5.843999862670898 43.32699966430664,-5.843999862670898 C43.32699966430664,-5.843999862670898 35.678001403808594,-26.393999099731445 35.678001403808594,-26.393999099731445 C35.678001403808594,-26.393999099731445 30.312000274658203,-26.393999099731445 30.312000274658203,-26.393999099731445 C30.312000274658203,-26.393999099731445 40.86199951171875,0.11299999803304672 40.86199951171875,0.11299999803304672 C40.86199951171875,0.11299999803304672 45.82899856567383,0.11299999803304672 45.82899856567383,0.11299999803304672 C45.82899856567383,0.11299999803304672 56.37900161743164,-26.393999099731445 56.37900161743164,-26.393999099731445z"
            />
          </g>
          <g opacity={1} transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(255,255,255)"
              fillOpacity={1}
              d=" M27.621999740600586,0 C27.621999740600586,0 27.621999740600586,-26.393999099731445 27.621999740600586,-26.393999099731445 C27.621999740600586,-26.393999099731445 22.871999740600586,-26.393999099731445 22.871999740600586,-26.393999099731445 C22.871999740600586,-26.393999099731445 22.871999740600586,0 22.871999740600586,0 C22.871999740600586,0 27.621999740600586,0 27.621999740600586,0z"
            />
          </g>
          <g opacity={1} transform="matrix(1,0,0,1,0,0)">
            <path
              fill="rgb(255,255,255)"
              fillOpacity={1}
              d=" M1.7760000228881836,-26.393999099731445 C1.7760000228881836,-26.393999099731445 1.7760000228881836,0 1.7760000228881836,0 C1.7760000228881836,0 19.61400032043457,0 19.61400032043457,0 C19.61400032043457,0 19.61400032043457,-4.599999904632568 19.61400032043457,-4.599999904632568 C19.61400032043457,-4.599999904632568 6.561999797821045,-4.599999904632568 6.561999797821045,-4.599999904632568 C6.561999797821045,-4.599999904632568 6.561999797821045,-26.393999099731445 6.561999797821045,-26.393999099731445 C6.561999797821045,-26.393999099731445 1.7760000228881836,-26.393999099731445 1.7760000228881836,-26.393999099731445z"
            />
          </g>
        </g>
        <g
          transform="matrix(1.2200000286102295,0,0,1.2200000286102295,234.8300018310547,252.9499969482422)"
          opacity={1}
          style={{ display: currentDisplay === 0 ? 'block' : 'none' }}
        >
          <g opacity={1} transform="matrix(1,0,0,1,-137.5,2.5)">
            <path
              fill="rgb(252,16,36)"
              fillOpacity={1}
              d=" M0,-31 C17.10890007019043,-31 31,-17.10890007019043 31,0 C31,17.10890007019043 17.10890007019043,31 0,31 C-17.10890007019043,31 -31,17.10890007019043 -31,0 C-31,-17.10890007019043 -17.10890007019043,-31 0,-31z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function ChevronDownIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M6 9l6 6l6 -6" />
    </svg>
  );
}

export function ErrorIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-exclamation-circle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M12 9v4" />
      <path d="M12 16v.01" />
    </svg>
  );
}

export function SuccessIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M9 12l2 2l4 -4" />
    </svg>
  );
}

export function SuccessFillIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-circle-check"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" />
    </svg>
  );
}

export function ConnectIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-heart-handshake"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
      <path d="M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25" />
      <path d="M12.5 15.5l2 2" />
      <path d="M15 13l2 2" />
    </svg>
  );
}

export function TicketIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-ticket"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M15 5l0 2" />
      <path d="M15 11l0 2" />
      <path d="M15 17l0 2" />
      <path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2" />
    </svg>
  );
}

export function EmailIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-mail"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
      <path d="M3 7l9 6l9 -6" />
    </svg>
  );
}

export function PhoneIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-phone"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
    </svg>
  );
}

export function ScanQrIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      fill="none"
      viewBox="0 0 538 538"
      className="position-scan__body__main"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="14.813"
        d="M367.75 506h69.125A69.128 69.128 0 00506 436.875V367.75m0-197.5v-69.125A69.127 69.127 0 00436.875 32H367.75m-197.5 474h-69.125A69.127 69.127 0 0132 436.875V367.75m0-197.5v-69.125A69.125 69.125 0 01101.125 32h69.125"
      ></path>
    </svg>
  );
}

export function BorderIco({ width = 32, height = 32, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-border-corner-rounded"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 20v-10a6 6 0 0 1 6 -6h10" />
    </svg>
  );
}

export function MomoIco({ width = 24, height, style }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 108.44 23.49"
      style={{ enableBackground: 'new 0 0 108.44 23.49', ...style }}
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: '\n .stmomo{fill:#A50064;}\n  ',
        }}
      />
      <g id="_x35_.-Kiểm-tra-giao-dịch">
        <g id="momo_icon_square_pinkbg">
          <g id="Group" transform="translate(4.000000, 5.500000)">
            <path
              id="Shape"
              className="stmomo"
              d="M37.78,17.33c6.13,0,11.09-4.94,11.09-11.05S43.92-4.76,37.78-4.76S26.7,0.18,26.7,6.29
    S31.65,17.33,37.78,17.33z M37.78,1.58c2.61,0,4.72,2.11,4.72,4.71s-2.11,4.71-4.72,4.71c-2.61,0-4.72-2.11-4.72-4.71
    S35.18,1.58,37.78,1.58z"
            />
            <path
              id="Shape_1_"
              className="stmomo"
              d="M92.64-4.82c-6.13,0-11.09,4.94-11.09,11.05s4.96,11.05,11.09,11.05
    c6.13,0,11.09-4.94,11.09-11.05S98.77-4.82,92.64-4.82z M92.64,10.93c-2.61,0-4.72-2.11-4.72-4.71c0-2.6,2.11-4.71,4.72-4.71
    c2.61,0,4.72,2.11,4.72,4.71C97.36,8.83,95.25,10.93,92.64,10.93z"
            />
            <path
              id="Path_1_"
              className="stmomo"
              d="M70.05-4.82c-1.88,0-3.6,0.62-4.98,1.66c-1.38-1.04-3.13-1.66-4.98-1.66
    c-4.59,0-8.32,3.72-8.32,8.29V17.3h6.37V3.39c0-1.04,0.83-1.87,1.88-1.87s1.88,0.83,1.88,1.87v13.88h6.37V3.39
    c0-1.04,0.83-1.87,1.88-1.87c1.04,0,1.88,0.83,1.88,1.87v13.88h6.34V3.45C78.34-1.1,74.64-4.82,70.05-4.82z"
            />
            <path
              id="Path_2_"
              className="stmomo"
              d="M15.19-4.76c-1.88,0-3.6,0.62-4.98,1.66C8.82-4.14,7.07-4.76,5.22-4.76
    c-4.62,0-8.35,3.72-8.35,8.29v13.8h6.37V3.45c0-1.04,0.83-1.87,1.88-1.87S7,2.41,7,3.45v13.88h6.37V3.45
    c0-1.04,0.83-1.87,1.88-1.87s1.88,0.83,1.88,1.87v13.88h6.37V3.53C23.49-1.04,19.78-4.76,15.19-4.76z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function VietQRIco({ width = 24, height, style }) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 2048 657"
      width={width}
      height={height}
      style={{ ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(125,30)"
        d="m0 0h20l18 4 14 6 12 8 13 12 6 8 34 58 14 24 68 116 4-5 14-24 17-29 14-24 51-87 16-27 10-13 10-9 13-8 15-6 17-3h14l16 3 13 5 15 8 14 9 12 11 7 8 8 13 6 16 3 18v11l-2 14-5 16-10 19-14 24-15 27-14 24-15 27-14 24-15 27-14 24-15 27-14 24-15 27-28 49-13 23-9 15-7 9-7 8-13 10-16 8-14 4-14 2h-11l-14-2-16-5-13-7-13-10-7-7-10-14-15-26-16-28-30-52-16-28-14-24-16-28-15-26-16-28-30-52-16-28-14-24-8-16-4-13-2-11v-19l3-15 6-16 9-14 9-10 10-9 15-9 16-8 12-4z"
        fill="#EF2532"
      />
      <path
        transform="translate(1369,229)"
        d="m0 0 19 1 22 4 24 7 18 8 19 10 13 9 10 8 13 12 11 14 9 14 8 17 5 15 4 20 1 9v32l-3 21-6 21-9 21-10 16-9 11-10 10 6 11 15 25 2 5h-69l-32-56-14-24-14-25-10-17-15-26v-2h67l10 16 13 22v2l4-4 5-12 3-11 2-19-1-14-4-17-8-19-10-16-12-13-11-8-15-8-13-4-13-2h-22l-17 3-12 4-14 7-14 11-9 10-10 16-7 18-3 13-1 8v22l3 18 5 15 6 12 10 13 13 11 16 9 21 7 18 3 11 1 10 17 14 25 9 16-3 2-26 2h-29l-21-3-22-6-20-8-21-11-16-12-10-9-9-9-11-15-9-16-8-20-5-22-2-16v-33l3-20 5-19 9-21 10-16 11-13 12-12 13-10 16-10 16-8 18-7 21-6 15-3z"
        fill="#1F437E"
      />
      <path
        transform="translate(1579,235)"
        d="m0 0h151l20 2 20 5 15 6 14 7 11 8 10 8 7 8 9 12 8 16 5 15 2 11 1 12v11l-2 18-4 16-8 18-10 14-9 10-13 10-14 8-5 1 65 90 6 8v2h-80l-9-12-15-22-33-48-16-23-15-22-16-23-15-22v-1h79l12 18v2l10-7 7-7 8-16 2-10v-14l-3-12-6-12-6-7-13-9-12-5-16-3-70-1v255h-73v-314z"
        fill="#1F437E"
      />
      <path
        transform="translate(757,232)"
        d="m0 0h182l8 3 6 4 7 8 3 9v12l-4 9-7 8-9 5-4 1h-146v72h145l11 4 6 5 6 10 2 11-2 10-6 10-8 6-9 3h-145v72h145l11 4 6 5 6 10 2 11-2 10-6 10-8 6-9 3h-181l-10-4-8-7-5-10-1-5v-270l4-11 7-8 9-5z"
        fill="#EF2532"
      />
      <path
        transform="translate(136,43)"
        d="m0 0h22l18 4 12 5 9 5 5 3 6 8 34 58 14 24 68 116-1 5-12 13-13 11-13 8-13 6-14 3h-11l-18-2-18-6-12-7-12-11-9-11-16-26-19-32-34-58-14-24-5-11-3-10v-22l3-11 5-10 8-10 9-8 16-8z"
        fill="#A22F22"
      />
      <path
        transform="translate(998,232)"
        d="m0 0h181l10 4 7 6 5 9 2 8-1 10-4 9-6 7-10 5-4 1h-59v236l-3 10-6 8-9 6-6 2h-12l-10-4-7-6-6-12-1-6v-234h-61l-9-3-10-9-4-8-1-3v-13l4-9 7-8 6-4z"
        fill="#EF2532"
      />
      <path
        transform="translate(647,232)"
        d="m0 0h12l10 4 8 7 5 10 1 5v269l-3 10-6 8-9 6-6 2h-12l-10-4-7-6-6-12-1-7v-264l2-9 6-10 8-6z"
        fill="#EF2532"
      />
      <path
        transform="translate(1949,99)"
        d="m0 0h19l6 9 12 21 11 19 2 1 2-5 19-32 7-11 2-2h19v91l-21 1-1-48-15 24-6 9-13 1-17-28-3-5-1 46-21 1-1-1z"
        fill="#434041"
      />
      <path
        transform="translate(1859,99)"
        d="m0 0h78l1 1v19h-28v71h-23l-1-70-27-1z"
        fill="#483F40"
      />
    </svg>
  );
}

export function AlepayIco({ width = 24, height, style }) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 2048 1535"
      width={width}
      height={height}
      style={{ ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(394,460)"
        d="m0 0h16l12 4 14 9 12 11 7 7 13 17 10 15 1 4 19-7 24-6 21-3h21l16 3 12 5 9 7 8 9 5 10 3 15v13l-3 19-8 24-9 20-13 23-11 16-3 4 1 5 13 24 15 28 17 34 8 19 5 16 1 6v21l-3 13-6 12-9 10-9 7-11 5-16 4-11 1h-11l-20-2-23-5-20-6-20-7-26-11-29-14-13-7-5 2-33 16-32 13-33 11-26 6-24 3h-16l-19-3-12-5-9-6-6-5-7-10-5-12-3-13v-13l5-19 7-19 13-29 10-21 10-19 15-28-1-4-10-14-11-19-8-15-10-25-5-19-1-7v-23l4-13 5-9 8-9 10-6 13-5 12-2h22l21 3 27 7 15 5 16-24 9-11 9-10 11-9 11-7 10-4zm-145 59-17 3-12 5-11 8-5 8-3 10v22l4 16 6 16 12 23 12 18 9 12h2l12-22 10-17 17-29 28-46 9-14-2-2-26-7-17-3-9-1zm286 0-21 3-24 6-7 3 2 5 16 28 15 25 16 28 14 24 11 20h2l11-15 12-19 11-21 6-16 3-12 1-7v-15l-3-11-4-8-9-8-10-5-9-3-13-2zm-134 7-16 28-16 27-15 26-56 96-5 8 1 5 16 15 8 7 14 12 14 11 16 13 18 13 18 12 5 2 19-13 14-10 12-9 13-10 13-11 11-9 15-14 11-11-7-14-28-48-15-26-16-27-15-26-16-27-12-20zm-121 208-13 22-9 16-6 15-2 9v14l4 9 5 5 9 4 16 2 25-2 29-6 27-8 9-3v-2l-16-11-21-16-16-13-14-12-12-11-8-7-5-5zm242 0-16 15-13 12-11 9-13 11-20 15-19 13v2l29 9 24 6 25 4h22l13-4 8-7 4-10v-13l-6-16-8-16-10-18-7-11z"
        fill="#FCD736"
      />
      <path
        transform="translate(1120,528)"
        d="m0 0h111l21 3 15 4 15 6 13 8 10 8 8 8 10 14 9 17 7 21 3 18v28l-4 22-7 19-7 13-8 11-9 10-9 8-13 8-16 7-16 4-17 2h-73v79l-3 17-5 10-4 5-11 7-8 3-6 1h-9l-11-3-9-5-7-6-5-8-3-11-1-7v-282l3-12 5-9 8-9 8-5 9-3zm43 71v97h46l17-3 14-7 10-10 6-11 2-8v-19l-4-13-6-9-5-6-11-7-16-4z"
        fill="#44A8DD"
      />
      <path
        transform="translate(1462,608)"
        d="m0 0h26l17 4 16 8 9 7 11 10 8-13 5-6 10-6 6-2 14-1 12 3 9 6 8 8 5 11 1 4v210l-3 11-5 10-9 9-10 5-4 1h-16l-11-4-8-6-6-7-6-12-6 5-7 8-12 9-11 5-13 3-9 1h-15l-16-2-17-5-17-8-14-10-10-9-11-11-11-16-8-15-7-20-4-21-1-10v-30l3-20 4-15 6-15 8-15 8-11 9-10 12-12 16-11 16-8 16-5zm14 73-11 3-8 4-10 9-6 7-7 15-3 13-1 9v14l2 15 5 15 7 11 8 9 10 6 11 4 7 1h9l10-2 9-4 9-6 7-7 8-13 4-11 3-17v-16l-2-14-4-12-6-11-10-11-11-7-9-3-5-1z"
        fill="#44A8DD"
      />
      <path
        transform="translate(901,608)"
        d="m0 0h29l17 3 16 5 19 9 14 10 12 11 10 11 10 15 8 17 6 19 3 16 1 10v15l-2 9-6 9-6 4-9 3h-157l8 17 9 12 10 8 11 5 12 3h24l19-5 34-16 10-3h14l10 5 7 7 5 8 2 6v12l-4 10-6 8-8 8-14 9-21 10-19 6-22 4-13 1h-20l-20-2-21-5-15-6-17-9-13-10-11-10-9-11-9-13-8-16-6-18-3-16-1-9v-25l3-22 5-19 7-17 8-14 10-13 17-17 14-10 19-10 19-6zm9 64-11 3-10 5-10 9-6 8-7 14-3 10h105l-1-7-6-16-7-10-8-8-12-6-9-2z"
        fill="#FCD736"
      />
      <path
        transform="translate(1677,609)"
        d="m0 0h13l10 3 9 6 8 11 8 17 15 38 19 48 11 28 5-11 23-58 20-50 9-17 5-6 9-6 11-3h12l13 4 11 8 7 10 3 9v14l-5 17-18 43-19 45-20 48-19 45-36 86-15 35-6 10-5 6-10 6-5 2-14 1-12-3-10-6-7-7-6-12-1-5v-9l4-16 34-80-1-5-23-54-38-90-17-40-5-17v-15l4-10 6-8 9-7 9-4z"
        fill="#44A8DD"
      />
      <path
        transform="translate(704,492)"
        d="m0 0h12l12 4 9 6 6 7 4 9 2 11v321l-3 14-4 8-8 8-10 5-6 2h-16l-11-4-9-7-5-6-4-9-2-12v-319l3-15 6-10 7-6 10-5z"
        fill="#FCD736"
      />
      <path
        transform="translate(498,968)"
        d="m0 0h16l9 4 5 4 4 6v2h2l2-4 4-5 10-6 3-1h18l10 5 5 5 5 8 2 8v56h-8l-1-55-3-9-3-4v-2l-10-4h-13l-10 5-6 9-2 8-1 52h-8l-1-56-3-9-4-5-9-4h-12l-10 5-6 8-2 5-1 6-1 50h-7l-1-1v-79l1-1h7v13h2l2-4 5-5 4-3z"
        fill="#494E51"
      />
      <path
        transform="translate(1064,968)"
        d="m0 0h16l9 4 5 4 5 7 7-8 10-6 3-1h18l12 6 6 8 3 7 1 5v56h-8l-1-56-4-10-5-5-7-3h-13l-8 4-5 5-4 8-1 5-1 52h-7l-1-1-1-56-4-9-5-5-7-3h-12l-10 5-6 8-3 11-1 50h-7l-1-80 1-1h7v13h2l2-4 5-5 7-4z"
        fill="#494E50"
      />
      <path
        transform="translate(1625,935)"
        d="m0 0h8v114l-1 1h-7l-1-16-9 10-8 5-11 3h-8l-9-2-8-4-10-9-5-8-3-10v-18l3-10 6-10 8-7 10-5 3-1h18l10 4 10 9 3 4zm-38 40-11 4-8 7-5 9-2 9v11l4 13 7 9 8 5 6 2h13l10-4 10-9 5-10 1-4v-15l-4-11-9-10-10-5-4-1z"
        fill="#495054"
      />
      <path
        transform="translate(1219,968)"
        d="m0 0h18l12 5 10 9 7 14 1 4v18l-3 10-6 10-9 8-8 4-9 2h-8l-9-2-9-5-10-10-1 40h-8v-105l1-1h7l1 16 9-10 8-5zm3 7-11 4-10 9-5 10-1 3v17l5 12 9 9 8 4 4 1h13l10-4 8-7 5-9 2-9v-10l-3-11-5-8-8-7-6-3-5-1z"
        fill="#494D4F"
      />
      <path
        transform="translate(220,968)"
        d="m0 0h17l10 4 8 6 7 8 4 9 2 11-1 14-5 13-9 10-9 6-12 3h-8l-13-4-8-6-6-6v-2h-2v41h-7v-106h7v17h2l2-4 5-6 10-6zm3 7-10 3-9 7-6 9-3 9v13l4 11 6 8 8 6 8 3h13l9-3 10-9 5-10 1-5v-15l-4-11-6-8-9-6-7-2z"
        fill="#494D4F"
      />
      <path
        transform="translate(1490,968)"
        d="m0 0h18l12 6 5 4 7 11 3 10 1 12-1 2h-66l3 12 5 8 8 7 8 3h15l10-4 9-7 4 2 2 3-7 7-12 6-10 2h-8l-12-3-11-7-8-11-4-11-1-6v-8l3-14 6-10 4-5 9-6zm2 7-9 4-7 6-6 12-1 9h58l-1-9-4-9-7-8-7-4-3-1z"
        fill="#494D4F"
      />
      <path
        transform="translate(645,968)"
        d="m0 0h18l10 4 9 8 7 14 2 10v8l-1 1h-66l4 13 5 8 6 5 10 4h14l10-4 8-6h4l3 3-2 4-10 7-10 4-6 1h-9l-9-2-10-5-9-9-5-10-2-7v-18l3-10 6-10 7-7 10-5zm2 7-10 5-7 7-5 10-1 9h58l-1-10-6-12-7-6-8-3z"
        fill="#494D4E"
      />
      <path
        transform="translate(313,968)"
        d="m0 0h14l9 2 10 6 6 9 2 6v59h-7v-12l-11 9-10 4-6 1h-8l-12-3-9-6-5-8-1-3v-11l3-8 4-5 8-5 11-3h21l15 3-3-15-7-8-8-3h-19l-15 5-3-7 12-5zm0 39-10 3-6 4-3 5-1 10 4 8 5 4 7 3h15l11-4 8-7 4-10v-12l-5-2-12-2z"
        fill="#494E50"
      />
      <path
        transform="translate(371,969)"
        d="m0 0h8l8 16 19 40 7 14 19-47 9-22 1-1h8l-3 10-17 40-16 38-7 11-8 6-3 1h-16l-7-3 2-7 7 2h12l6-4 4-5 4-9-12-25-14-29-11-23z"
        fill="#494F51"
      />
      <path
        transform="translate(741,968)"
        d="m0 0h18l10 4 8 8 4 9 1 4v57h-8l-1-56-4-9-4-5-9-4h-14l-9 4-5 4-5 10-1 4-1 52h-8v-81h8l1 13 7-8 6-4z"
        fill="#494E51"
      />
      <path
        transform="translate(936,968)"
        d="m0 0h16l15 5 5 3-2 5-3 2-11-5-8-2h-9l-8 3-3 1-2 6 1 9 7 5 24 8 9 5 6 7 1 4v8l-3 8-5 5-8 5-4 1h-17l-13-4-10-6v-3l3-4 5 2 13 6 5 1h12l9-4 4-7-1-9-6-5-13-5-15-5-8-5-4-5-1-3v-10l4-8 7-6z"
        fill="#494E50"
      />
      <path
        transform="translate(1395,934)"
        d="m0 0h8l7 2v7h-18l-5 3-3 6-2 17h28v8h-28v73h-7l-1-1v-72h-11v-8h11v-11l2-10 4-6 7-6z"
        fill="#49565C"
      />
      <path
        transform="translate(814,944)"
        d="m0 0h8v25h28v8h-28l1 57 3 5 4 3 4 1h8l8-2v7l-6 3h-14l-9-4-5-6-2-6v-58h-11l-1-1v-6l1-1h11z"
        fill="#495054"
      />
      <path transform="translate(1292,935)" d="m0 0h8v115h-8z" fill="#494A4A" />
      <path transform="translate(1428,969)" d="m0 0h7l1 1v79l-1 1h-7z" fill="#49565D" />
      <path transform="translate(1e3 969)" d="m0 0h7v81h-7l-1-1v-79z" fill="#49565D" />
      <path transform="translate(1332,969)" d="m0 0h7v81h-7z" fill="#494B4B" />
      <path transform="translate(1427,950)" d="m0 0h10v10h-10z" fill="#495358" />
      <path transform="translate(998,950)" d="m0 0h10v10h-10z" fill="#495358" />
      <path transform="translate(1331,950)" d="m0 0h9v10h-9z" fill="#4A4A4A" />
    </svg>
  );
}

export function ShopeePayIco({ width = 24, height = 24, style }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 732.57 326.48"
      style={{ enableBackground: 'new 0 0 732.57 326.48', ...style }}
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: '\n    .stspp{fill-rule:evenodd;clip-rule:evenodd;fill:#ED4C2F;}\n  ',
        }}
      />
      <path
        className="stspp"
        d="M171,232.37c-19.6,3.8-44.9-2.8-58.6-17.5c-6.2-6.6,3.8-16.7,10-10c9.2,9.9,25.7,14.6,39.1,14.3
    c17.1-0.4,32.3-15.9,22.6-33.3c-13.5-24.1-46.6-17.3-63.7-36.3c-13.8-15.3-7.2-39.3,8.9-49.9c16.9-11.1,46-10.7,59.9,5.2
    c6,6.8-4,16.9-10,10c-11.2-12.9-37.7-11.1-47.8,2.1c-14.4,18.9,7.1,29.1,22.2,33.6c20.7,6.3,43.6,17.7,47.4,41.4
    C204.1,211.07,189.3,228.77,171,232.37L171,232.37z M40.1,53.37h233.4c15.6,0,28.2,12.7,28.2,28.2v163.4c0,15.6-12.7,28.2-28.2,28.2
    H33.3c-15.6,0-28.2-12.6-28.3-28.2V43.17c0-7.3,6.1-12.4,13.3-13.3l215.2-27.5c7.4,0,13.3,6,13.3,13.3v22.8H26.6
    C26.6,48.17,29.5,53.37,40.1,53.37L40.1,53.37z"
      />
      <path
        className="stspp"
        d="M397.6,15.17c-9.3-10.2-28.7-10.5-40-3.4c-10.8,6.8-15.2,22.3-6,32.1c11.4,12.1,33.5,7.8,42.5,23.3
    c6.5,11.2-3.7,21.2-15.1,21.4c-9,0.2-20-2.8-26.1-9.2c-4.1-4.3-10.8,2.1-6.7,6.4c9.1,9.5,26,13.7,39.1,11.2
    c12.2-2.3,22.1-13.7,20.1-25.9c-2.5-15.2-17.8-22.6-31.6-26.6c-10-2.9-24.4-9.5-14.8-21.6c6.8-8.5,24.4-9.6,31.9-1.4
    C394.9,25.97,401.6,19.57,397.6,15.17L397.6,15.17z M464,61.37v31.9c0,6-9.5,6-9.5,0v-31.2c-0.3-3.8-2.5-7.2-5.8-9.1
    c-6.7-2.9-19-1.6-26.2,7.6v32.7c0,6-9.5,6-9.5,0v-81.8c0-6,9.5-6,9.5,0v36.8c11.6-7.7,26.3-6.9,33.3-2.1
    C461.1,49.27,464.2,55.17,464,61.37z M622.4,65.57c0.1-0.4,0.2-0.7,0.3-1c2.3-7.5,10-11.8,17.8-12c9-0.2,14,5.8,15.6,13H622.4z
     M666,70.17c-0.2-12.5-6.8-23.9-20.5-26.4c-11.8-2.2-25.6,3.9-30.6,14.6c-5.2,11.1-3,26.4,7.3,34.2c11.1,8.4,28.5,5.8,39.9-0.4
    c5.3-2.9,0.5-10.8-4.8-7.9c-7.2,3.9-16.7,5.9-24.8,3.2c-6.1-2-9.5-7-10.5-12.7h39.3C663.9,74.77,666,72.77,666,70.17L666,70.17z
     M685.3,65.57c0.1-0.3,0.2-0.7,0.3-1c2.3-7.5,10-11.8,17.8-12c9-0.2,14,5.8,15.6,13H685.3z M729,70.07c-0.2-12.5-6.8-23.9-20.5-26.4
    c-11.8-2.2-25.6,3.9-30.6,14.6c-5.2,11.1-3,26.4,7.3,34.2c11.1,8.4,28.5,5.8,39.9-0.4c5.3-2.9,0.5-10.8-4.8-7.9
    c-7.2,4-16.7,5.9-24.8,3.2c-6.1-2-9.5-7-10.5-12.7h39.3C726.8,74.67,728.9,72.67,729,70.07L729,70.07z M503.2,53.27
    c-9.9,0-18,7.8-18,17.4s8,17.4,18,17.4s17.9-7.8,17.9-17.4S513,53.27,503.2,53.27z M503.2,97.87c-15.5,0-28.1-12.2-28.1-27.3
    s12.6-27.3,28.1-27.3s28.1,12.2,28.1,27.3S518.7,97.87,503.2,97.87z M572.9,88.07c-9.9,0-17.9-7.8-17.9-17.4
    c0.1-8.7,6.5-15.9,15.1-17.2h0.2c0.9-0.1,1.8-0.2,2.7-0.2c7,0,13.4,4,16.4,10.4c0,0,0,0,0,0.1c1,2.2,1.5,4.5,1.5,6.9
    C590.8,80.27,582.8,88.07,572.9,88.07L572.9,88.07z M572.9,43.37c-8,0-15.6,3.3-21,9.1v-6.5c0-5.9-9.5-5.9-9.5,0v77.1
    c0,5.9,9.5,5.9,9.5,0v-34.3c5.4,5.9,13,9.2,21,9.1c15.5,0,28.1-12.2,28.1-27.3S588.4,43.37,572.9,43.37L572.9,43.37z"
      />
      <path
        className="stspp"
        d="M525.4,184.07c18,0,32.7,14.6,32.7,32.7s-14.6,32.7-32.7,32.7s-32.7-14.6-32.7-32.7S507.4,184.07,525.4,184.07
    L525.4,184.07z M562,161.27h22.1v110.9H562v-12.5c-23.7,20.2-59.4,17.3-79.6-6.4c-20.2-23.7-17.3-59.4,6.4-79.6
    c21.1-17.9,52-17.9,73.1,0v-12.4H562z M370,201.97v-59.9h34c19.1,0,34.6,13.4,34.6,30s-15.5,30-34.6,30L370,201.97z M344.9,273.17
    H370v-46h34c35.2,0,63.7-24.7,63.7-55.1s-28.6-55.1-63.7-55.1h-59.2L344.9,273.17L344.9,273.17z M644.1,320.67h-30l32.1-60.7
    l-52.8-99.7H626l36.5,68.9l36.5-68.9h30L644.1,320.67z"
      />
    </svg>
  );
}

export function ZaloIco({ width = 24, height = 24, style }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 780.57 230.86"
      style={{ enableBackground: 'new 0 0 780.57 230.86', ...style }}
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: '\n    .stzl{fill:#0068FF;}\n    .stzl1{fill:#03CA77;}\n  ',
        }}
      />
      <g>
        <g>
          <g>
            <g id="XMLID_338_">
              <g id="XMLID_341_">
                <path
                  id="XMLID_347_"
                  className="stzl"
                  d="M240.75,86.38c-3.14-3.21-7.14-4.82-11.99-4.82c-7.14,0-12.34,3.43-15.62,10.27
        c-7-8.22-16.56-12.32-28.68-12.32c-14.55,0-26.8,5.62-36.71,16.84c-9.91,11.23-14.87,24.93-14.87,41.08s4.96,29.85,14.87,41.08
        c9.92,11.23,22.16,16.84,36.71,16.84c12.12,0,21.68-4.11,28.68-12.33c3.27,6.85,8.48,11.39,15.62,11.39
        c4.85,0,8.85-1.61,11.99-4.83c3.14-3.21,4.7-7.15,4.7-11.81V98.19C245.45,93.54,243.88,89.6,240.75,86.38z M205.97,156.89
        c-4.07,5.24-9.68,7.86-16.8,7.86c-7.14,0-12.74-2.62-16.8-7.86c-4.06-5.25-6.1-11.73-6.1-19.46c0-7.72,2.03-14.21,6.1-19.45
        c4.07-5.25,9.66-7.86,16.8-7.86c7.13,0,12.74,2.62,16.8,7.86c4.07,5.24,6.1,11.73,6.1,19.45
        C212.07,145.15,210.03,151.64,205.97,156.89z"
                />
                <path
                  id="XMLID_346_"
                  className="stzl"
                  d="M283.25,190.83c-3.14,3.22-7.14,4.83-11.98,4.83c-4.86,0-8.85-1.61-11.99-4.83
        c-3.14-3.21-4.71-7.15-4.71-11.81V34.54c0-4.65,1.57-8.6,4.71-11.81c3.14-3.22,7.13-4.82,11.99-4.82
        c4.84,0,8.84,1.61,11.98,4.82c3.14,3.22,4.71,7.16,4.71,11.81v144.48C287.95,183.68,286.39,187.62,283.25,190.83L283.25,190.83
        z"
                />
                <path
                  id="XMLID_343_"
                  className="stzl"
                  d="M393.86,96.34c-10.7-11.23-24.33-16.84-40.88-16.84c-16.55,0-30.07,5.55-40.55,16.64
        c-10.49,11.09-15.74,24.85-15.74,41.29c0,16.43,5.24,30.2,15.74,41.29c10.49,11.09,24,16.64,40.55,16.64
        c16.56,0,30.18-5.61,40.88-16.84c10.27-10.96,15.41-24.65,15.41-41.08C409.27,120.99,404.13,107.3,393.86,96.34z
         M369.78,156.89c-4.07,5.24-9.67,7.86-16.81,7.86c-7.14,0-12.74-2.62-16.8-7.86c-4.07-5.25-6.1-11.73-6.1-19.46
        c0-7.72,2.03-14.21,6.1-19.45c4.06-5.25,9.66-7.86,16.8-7.86c7.14,0,12.74,2.62,16.81,7.86c4.07,5.24,6.09,11.73,6.09,19.45
        C375.87,145.15,373.85,151.64,369.78,156.89z"
                />
                <path
                  id="XMLID_342_"
                  className="stzl"
                  d="M112.06,84.5c11.79-15.22,17.7-25.47,17.7-30.75c0-12.2-7.68-18.31-23.05-18.31H23.43
        c-6.37,0-11.29,1.51-14.79,4.51c-3.49,3.01-5.24,6.92-5.24,11.73c0,4.82,1.75,8.73,5.24,11.74c3.5,3.01,8.42,4.51,14.79,4.51
        h57.89l-71.26,92.08c-4.66,6.02-6.69,11.37-6.98,16.03c-0.84,13.18,5.02,20.7,26.55,20.08h83.6c13.36,0,20.03-5.6,20.03-16.82
        c0-11.21-6.67-16.81-20.03-16.81H51.75L112.06,84.5L112.06,84.5z"
                />
              </g>
              <g id="XMLID_339_">
                <path
                  id="XMLID_340_"
                  className="stzl1"
                  d="M489.56,68.43h-21.98v45.68h21.98c6.6,0,11.96-2.15,16.05-6.46
        c4.09-4.31,6.14-9.77,6.14-16.37c0-6.6-2.05-12.06-6.14-16.37C501.52,70.58,496.16,68.43,489.56,68.43z"
                />
                <g>
                  <path
                    className="stzl1"
                    d="M598.52,110.24c-7.14,0-12.74,2.62-16.8,7.86c-4.06,5.24-6.1,11.73-6.1,19.45
          c0,7.73,2.03,14.21,6.1,19.46c4.07,5.24,9.66,7.86,16.8,7.86c7.13,0,12.74-2.62,16.8-7.86c4.07-5.25,6.1-11.73,6.1-19.46
          c0-7.72-2.03-14.21-6.1-19.45C611.25,112.86,605.64,110.24,598.52,110.24z"
                  />
                  <path
                    className="stzl1"
                    d="M758.61,3.15H438.17c-10.63,0-19.25,8.62-19.25,19.25v186.69c0,10.63,8.62,19.25,19.25,19.25h249.19
          c-2.65-2.52-3.99-5.46-3.99-8.83c0-2.75,0.62-5.64,1.86-8.67l11.86-26.38l-32.8-81.9c-0.96-2.34-1.44-4.88-1.44-7.63
          c0-3.58,1.51-6.6,4.54-9.08c3.02-2.47,6.19-3.71,9.49-3.71c7.29,0,12.24,3.51,14.85,10.52l20.42,55.91l21.87-55.91
          c2.75-7.02,8.52-10.52,15.68-10.52c3.3,0,6.46,1.24,9.49,3.71c3.02,2.48,4.54,5.5,4.54,9.08c0,2.75-0.48,5.3-1.44,7.63
          l-49.41,117.98c-1.33,3.3-2.93,5.89-4.8,7.8h50.53c10.63,0,19.25-8.62,19.25-19.25V22.4C777.86,11.77,769.24,3.15,758.61,3.15
          z M529.42,124.3c-10.05,9.19-22.7,13.79-37.92,13.79h-23.92v40.45c0,5.32-1.51,9.45-4.53,12.39
          c-3.02,2.95-6.89,4.42-11.63,4.42c-4.74,0-8.62-1.47-11.63-4.42c-3.02-2.94-4.52-7.07-4.52-12.39V52.34
          c0-11.2,5.6-16.81,16.81-16.81h38.13c15.94,0,29.12,4.78,39.54,14.33c10.41,9.55,15.62,21.94,15.62,37.17
          C545.36,102.39,540.04,114.82,529.42,124.3z M654.8,177.91c0,4.66-1.57,8.6-4.7,11.81c-3.14,3.22-7.14,4.83-11.99,4.83
          c-7.14,0-12.34-4.53-15.62-11.39c-7,8.22-16.56,12.33-28.68,12.33c-14.55,0-26.8-5.61-36.71-16.84
          c-9.91-11.23-14.87-24.93-14.87-41.08c0-16.16,4.96-29.85,14.87-41.08c9.92-11.22,22.16-16.84,36.71-16.84
          c12.12,0,21.68,4.1,28.68,12.32c3.27-6.84,8.48-10.27,15.62-10.27c4.85,0,8.85,1.61,11.99,4.82c3.14,3.22,4.7,7.16,4.7,11.81
          V177.91z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function VnpayIco({ width = 24, height = 24, style }) {
  return (
    <svg
      data-name="Layer 1"
      width={width}
      height={height}
      style={{
        ...style,
      }}
      viewBox="0 0 138.32 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html:
              '.cls-1,.cls-4{fill:#005baa;}.cls-2,.cls-5{fill:#ed1c24;}.cls-3{fill:#009edb;}.cls-4,.cls-5{fill-rule:evenodd;}',
          }}
        />
      </defs>
      <path
        className="cls-1"
        d="m30.18 13.68-5.47 5.47-0.94 0.95-1.27 1.27-0.2 0.19-0.55 0.56-0.2 0.19-1.87 1.87-0.2 0.19a8.4 8.4 0 0 1-1.84 1.39 7.83 7.83 0 0 1-1 0.47 8.07 8.07 0 0 1-2.42 0.53 8.47 8.47 0 0 1-1.51 0 8.17 8.17 0 0 1-3.12-1 5.52 5.52 0 0 1-1.2-0.84l-0.23-0.23-7.29-7.36-0.15-0.15a2.61 2.61 0 0 1-0.34-0.46 2.74 2.74 0 0 1-0.38-1.4 1.69 1.69 0 0 1 0-0.23v-0.35-0.13a2.8 2.8 0 0 1 0.5-1 2.09 2.09 0 0 1 0.2-0.22l0.13-0.13 7.85-7.75 4.7-4.69a2.79 2.79 0 0 1 3.81-0.13z"
      />
      <path
        className="cls-2"
        d="M16.05,31.12a4.36,4.36,0,0,1-1.83-.41l-1.49-1.48-.37-.36-.06-.07-.69-.69L8.14,24.6l.23.23a5.52,5.52,0,0,0,1.21.85,8.17,8.17,0,0,0,3.12,1,8.47,8.47,0,0,0,1.51,0,8.07,8.07,0,0,0,2.42-.53,7.83,7.83,0,0,0,1-.47,8.4,8.4,0,0,0,1.84-1.39l.2-.19h0l1.87-1.87h0l.2-.19.55-.56.2-.19,1.27-1.27.94-.95L26,17.87l.2-.2,8.05-8L37.55,6l0,0,.18-.17a2.6,2.6,0,0,1,3.67,0l1.82,1.82h0l.06,0a3,3,0,0,0-2.22.85l-6.15,6-.06.07L24.17,25.21h0l-3.95,3.87,0,0-.24.25a7,7,0,0,1-1.83,1.28,5,5,0,0,1-1.18.4,4.45,4.45,0,0,1-.71.09Z"
      />
      <path
        className="cls-2"
        d="M53.08,21.17l-.2.2-8.71,8.84L35,39.5a7.54,7.54,0,0,1-.92.79l0,0-.13.09h0a8.43,8.43,0,0,1-10.71-.75h0L23,39.49l-1.57-1.57L17,33.49,15.52,32l-.2-.21a4.37,4.37,0,0,0,.72.06h.21a4.83,4.83,0,0,0,.84-.11,5.39,5.39,0,0,0,1.35-.46,7.86,7.86,0,0,0,2-1.42l.27-.29,3.4-3.34h0l11.69-11.5.06-.08L41.6,9.09a2.27,2.27,0,0,1,2.83-.25l1.34,1.35h0l7.3,7.31a1.71,1.71,0,0,1,.18.2A2.59,2.59,0,0,1,53.08,21.17Z"
      />
      <path
        className="cls-3"
        d="M24.86,11.49a.56.56,0,0,1-.76,0A8.87,8.87,0,1,0,11.51,24l2.7,2.72a.21.21,0,0,1,0,.06h0a8,8,0,0,1-1.47,0l-2-2a9.93,9.93,0,0,1,14.1-14h0A.53.53,0,0,1,24.86,11.49Z"
      />
      <path
        className="cls-3"
        d="M29,14.89l-.75.74-1.31-1.32a.53.53,0,0,1,0-.75.53.53,0,0,1,.75,0Z"
      />
      <path
        className="cls-3"
        d="M17.68,25.74l0,0a7.4,7.4,0,0,1-1,.46L13,22.52a6.8,6.8,0,0,1-.78-8.64.54.54,0,0,1,.74-.14.53.53,0,0,1,.13.74,5.74,5.74,0,0,0,.66,7.29Z"
      />
      <path
        className="cls-3"
        d="m26.76 17.1-0.73 0.73-4.13-4.17a5.74 5.74 0 0 0-5.9-1.39 0.53 0.53 0 1 1-0.33-1 6.77 6.77 0 0 1 6.93 1.68z"
      />
      <path
        className="cls-3"
        d="M24.55,19.32l-.75.75-4.15-4.18A2.6,2.6,0,0,0,16,19.56l2.67,2.69a.53.53,0,0,1-.75.75L15.2,20.31a3.67,3.67,0,0,1,5.21-5.16Z"
      />
      <path className="cls-3" d="M22.33,21.53l0,0-.55.56-.18.17L17.43,18.1a.53.53,0,0,1,.75-.75Z" />
      <path
        className="cls-4"
        d="M126.68,21.3l-6.18-8.86-.62-.57H126l4.13,6.69.33-.27,2.49-3.71a1.94,1.94,0,0,0-.34-2.71h5.75l-6.65,9.42v6.84l1.17,1.4H125.7l1-1.38c0-2.27-.08-4.58,0-6.85Zm-16.77-9.43a2.54,2.54,0,0,1,.7,1.51,2.08,2.08,0,0,1-.13,1l-4.59,13.32a5,5,0,0,1-1.31,1.74h5a2,2,0,0,1-.7-1.19,1.88,1.88,0,0,1,0-1l1-3.16h5.83l.91,2.44a2.8,2.8,0,0,1,.17.76,2.3,2.3,0,0,1-.93,2.19h7.85a7.2,7.2,0,0,1-1.87-2.28l-5.74-15.38Zm5,10h-4.17l2-5.76,2.15,5.76ZM94,11.88h8.75a4.8,4.8,0,0,1,4.79,4.79v.59A4.8,4.8,0,0,1,102.77,22l-2.19.07a4.48,4.48,0,0,0,2.27-4.69c-.17-1.48-.93-2.9-2.2-2.93h-.8V27.56a1,1,0,0,0,.18.59,9,9,0,0,0,.8,1.07l.23.28h-6.8l.29-.39a4.33,4.33,0,0,0,.53-.91,1.38,1.38,0,0,0,.13-.6V13.49C95.18,12.75,94.45,12.33,94,11.88Z"
      />
      <path
        className="cls-5"
        d="M57.15,11.79h5.49L67.25,25l3.91-10.94a1.24,1.24,0,0,0-.16-.93c-.21-.45-.44-.88-.66-1.32h4.1c-.24.89-.6,1.87-.91,2.77L68.23,30a8.68,8.68,0,0,1-4.3-2,7.45,7.45,0,0,1-1.73-3.11L57.77,13.1a10.45,10.45,0,0,0-.62-1.31ZM79.07,18v9.44c0,.38.09.45.33.76l1.08,1.41H75.31l.87-1.33a1.4,1.4,0,0,0,.32-.92V14.15l-1.45-2.36h5.36L89.08,23v-8.9a1.43,1.43,0,0,0-.31-.93c-.29-.45-.6-.88-.89-1.32H93L92,13.22c-.24.3-.33.37-.33.76V30a7.31,7.31,0,0,1-5.39-2.81Z"
      />
      <path
        className="cls-3"
        d="M62.64,35.56c0,.7.3,1.07,1.07,1.07a2.5,2.5,0,0,0,.88-.16c.14-.06.18,0,.18.13v.08c0,.12,0,.17-.18.24a2.19,2.19,0,0,1-.87.15c-1.06,0-1.56-.47-1.56-1.51v-1A1.38,1.38,0,0,1,63.71,33a2.42,2.42,0,0,1,.85.16c.14.05.17.11.17.23v.08c0,.15-.06.19-.19.14a2.11,2.11,0,0,0-.85-.17c-.74,0-1,.36-1,1.14Z"
      />
      <path
        className="cls-3"
        d="M63.72,37.08c-1.07,0-1.57-.49-1.57-1.52v-1A1.38,1.38,0,0,1,63.71,33a2.42,2.42,0,0,1,.85.16c.15.06.18.12.18.24v.08c0,.08,0,.13,0,.15s-.08,0-.15,0a2.3,2.3,0,0,0-.85-.16c-.72,0-1,.35-1,1.13v1c0,.73.32,1.06,1.06,1.06a2.28,2.28,0,0,0,.87-.16c.08,0,.12,0,.15,0s0,.07,0,.15v.08c0,.13,0,.18-.18.24A2,2,0,0,1,63.72,37.08Zm0-4.07a1.37,1.37,0,0,0-1.55,1.57v1c0,1,.5,1.5,1.56,1.5a1.92,1.92,0,0,0,.86-.15c.15-.06.18-.11.18-.23V36.6c0-.08,0-.12,0-.14s-.06,0-.13,0a2.33,2.33,0,0,1-.88.16c-.74,0-1.08-.33-1.08-1.07v-1c0-.79.33-1.14,1.06-1.14a2.2,2.2,0,0,1,.86.16c.06,0,.1,0,.13,0a.17.17,0,0,0,0-.14v-.08c0-.11,0-.17-.18-.23A2.32,2.32,0,0,0,63.71,33Z"
      />
      <path
        className="cls-3"
        d="M65.42,33c0-.17,0-.2.19-.2h.07c.16,0,.19,0,.19.2v1.41a1.08,1.08,0,0,1,1-.41C67.58,34,68,34.3,68,35v1.8c0,.16,0,.19-.19.19h-.08c-.16,0-.19,0-.19-.19V35.07c0-.48-.21-.69-.78-.69s-.84.23-.84.79v1.65c0,.16,0,.19-.19.19h-.07c-.15,0-.19,0-.19-.19Z"
      />
      <path
        className="cls-3"
        d="M67.76,37h-.08c-.16,0-.19,0-.19-.2V35.07c0-.49-.23-.68-.78-.68s-.83.23-.83.78v1.65c0,.16,0,.2-.2.2h-.07c-.16,0-.2,0-.2-.2V33c0-.18,0-.21.2-.21h.07c.16,0,.2,0,.2.21v1.39a1.08,1.08,0,0,1,1-.4c.75,0,1.13.36,1.13,1.08v1.8C68,37,67.93,37,67.76,37Zm-1.05-2.65c.56,0,.79.21.79.7v1.75c0,.16,0,.18.18.18h.08c.16,0,.19,0,.19-.18V35c0-.71-.38-1.06-1.12-1.06a1,1,0,0,0-1,.41h0V33c0-.16,0-.19-.18-.19h-.07c-.15,0-.19,0-.19.19v3.87c0,.16,0,.18.19.18h.07c.16,0,.18,0,.18-.18V35.17C65.86,34.61,66.12,34.37,66.71,34.37Z"
      />
      <path
        className="cls-3"
        d="M68.6,35.79v-.56c0-.85.45-1.28,1.34-1.28s1.33.44,1.33,1.28v.56c0,.86-.44,1.28-1.33,1.28S68.6,36.63,68.6,35.79Zm2.21-.56c0-.59-.21-.85-.87-.85s-.88.26-.88.85v.56c0,.59.22.85.88.85s.87-.26.87-.85Z"
      />
      <path
        className="cls-3"
        d="M69.94,37.08c-.92,0-1.34-.41-1.34-1.29v-.56a1.31,1.31,0,0,1,.33-1,1.44,1.44,0,0,1,1-.32c.91,0,1.33.41,1.33,1.29v.56A1.16,1.16,0,0,1,69.94,37.08Zm0-3.12a1.41,1.41,0,0,0-1,.31,1.27,1.27,0,0,0-.33,1v.56c0,.87.42,1.27,1.33,1.27a1.38,1.38,0,0,0,1-.31,1.27,1.27,0,0,0,.33-1v-.56C71.26,34.36,70.84,34,69.94,34Zm0,2.69c-.64,0-.89-.24-.89-.86v-.56c0-.62.24-.86.89-.86s.88.24.88.86v.56C70.82,36.42,70.58,36.65,69.94,36.65Zm0-2.26c-.64,0-.87.22-.87.84v.56c0,.61.24.84.87.84s.87-.22.87-.84v-.56C70.81,34.61,70.57,34.39,69.94,34.39Z"
      />
      <path
        className="cls-3"
        d="M73.48,35.21c0-.8.43-1.26,1.36-1.26a1.48,1.48,0,0,1,.53.08c.15,0,.19.09.19.23v.06c0,.15,0,.2-.19.15a1.42,1.42,0,0,0-.52-.09c-.68,0-.91.27-.91.84v.59c0,.61.27.83,1,.83a1.5,1.5,0,0,0,.54-.08c.14-.05.18,0,.18.15v.06c0,.13,0,.18-.19.22a1.71,1.71,0,0,1-.57.08c-.93,0-1.37-.4-1.37-1.26Z"
      />
      <path
        className="cls-3"
        d="M74.85,37.08a1.49,1.49,0,0,1-1-.31,1.26,1.26,0,0,1-.34-1v-.6a1.23,1.23,0,0,1,.34-.93,1.39,1.39,0,0,1,1-.34,1.69,1.69,0,0,1,.53.08c.16,0,.19.1.19.24v.06c0,.09,0,.14,0,.16a.16.16,0,0,1-.15,0,1.72,1.72,0,0,0-.52-.08c-.65,0-.91.24-.91.83v.59c0,.6.26.82,1,.82a1.46,1.46,0,0,0,.54-.08c.07,0,.11,0,.14,0s.05.07.05.16v.06c0,.14,0,.19-.2.23A1.91,1.91,0,0,1,74.85,37.08Zm0-3.12c-.89,0-1.35.43-1.35,1.25v.6c0,.86.43,1.25,1.36,1.25a2,2,0,0,0,.57-.07c.15,0,.19-.09.19-.22v-.06c0-.08,0-.13,0-.15s-.07,0-.13,0a1.82,1.82,0,0,1-.55.08c-.69,0-1-.24-1-.84v-.59c0-.6.27-.85.92-.85a1.46,1.46,0,0,1,.52.09c.07,0,.11,0,.14,0s0-.07,0-.15v-.06c0-.13,0-.18-.18-.23A1.74,1.74,0,0,0,74.84,34Z"
      />
      <path
        className="cls-3"
        d="M76.5,35.93c0,.48.2.71.81.71s.81-.22.81-.71V34.2c0-.15,0-.19.2-.19h.06c.17,0,.2,0,.2.19v1.73c0,.74-.37,1.14-1.27,1.14S76,36.69,76,35.93V34.2c0-.15,0-.19.2-.19h.06c.17,0,.2,0,.2.19Z"
      />
      <path
        className="cls-3"
        d="M77.31,37.08c-.84,0-1.27-.39-1.27-1.15V34.2c0-.15,0-.2.19-.2h.07c.17,0,.2,0,.2.2v1.73c0,.51.23.7.81.7s.8-.19.8-.7V34.2c0-.15,0-.2.21-.2h.06c.18,0,.2,0,.2.2v1.73a1.1,1.1,0,0,1-.29.85A1.39,1.39,0,0,1,77.31,37.08ZM76.23,34c-.14,0-.18,0-.18.18v1.73a1.07,1.07,0,0,0,.31.85,1.38,1.38,0,0,0,1,.28,1.36,1.36,0,0,0,1-.29,1.07,1.07,0,0,0,.29-.84V34.2c0-.14,0-.18-.19-.18h-.06c-.15,0-.19,0-.19.18v1.73c0,.52-.23.72-.82.72s-.82-.2-.82-.72V34.2c0-.14,0-.18-.19-.18Z"
      />
      <path
        className="cls-3"
        d="M79.19,35.79v-.56c0-.85.44-1.28,1.34-1.28s1.32.44,1.32,1.28v.56c0,.86-.44,1.28-1.32,1.28S79.19,36.63,79.19,35.79Zm2.21-.56c0-.59-.21-.85-.87-.85s-.89.26-.89.85v.56c0,.59.23.85.89.85s.87-.26.87-.85Zm-1.3-2.08c.14-.22.23-.3.43-.3s.28.06.43.3l.23.36c.07.11,0,.14-.08.14h0a.23.23,0,0,1-.25-.14l-.14-.24c-.09-.17-.19-.17-.29,0l-.13.24a.24.24,0,0,1-.25.14h-.06c-.12,0-.14,0-.07-.14Zm.22,4.46a.3.3,0,1,1,0,.43A.3.3,0,0,1,80.32,37.61Z"
      />
      <path
        className="cls-3"
        d="M80.53,38.13a.31.31,0,0,1-.3-.3.29.29,0,0,1,.09-.22h0a.27.27,0,0,1,.21-.09.31.31,0,0,1,.31.31.27.27,0,0,1-.09.21A.31.31,0,0,1,80.53,38.13Zm0-.6a.29.29,0,0,0-.21.09h0a.3.3,0,0,0-.08.21.32.32,0,0,0,.08.21.31.31,0,0,0,.42,0,.29.29,0,0,0,.09-.21.31.31,0,0,0-.3-.3Zm0-.45c-.92,0-1.35-.41-1.35-1.29v-.56a1.31,1.31,0,0,1,.34-1,1.42,1.42,0,0,1,1-.32c.91,0,1.33.41,1.33,1.29v.56A1.16,1.16,0,0,1,80.53,37.08Zm0-3.12a1.39,1.39,0,0,0-1,.31,1.27,1.27,0,0,0-.33,1v.56c0,.87.42,1.27,1.33,1.27a1.4,1.4,0,0,0,1-.31,1.27,1.27,0,0,0,.33-1v-.56C81.85,34.36,81.43,34,80.53,34Zm0,2.69c-.64,0-.89-.24-.89-.86v-.56c0-.62.24-.86.89-.86s.87.24.87.86v.56C81.4,36.42,81.17,36.65,80.53,36.65Zm0-2.26c-.64,0-.88.22-.88.84v.56c0,.61.25.84.88.84s.86-.22.86-.84v-.56C81.39,34.61,81.16,34.39,80.53,34.39Zm.58-.73h0a.23.23,0,0,1-.25-.15l-.14-.23c0-.09-.1-.13-.14-.13h0s-.1,0-.14.13l-.14.23a.23.23,0,0,1-.25.15h-.06c-.07,0-.1,0-.11,0s0-.06,0-.11l.23-.36c.15-.22.23-.3.44-.3s.28.06.43.3l.23.36c0,.05.06.09,0,.11S81.18,33.66,81.11,33.66Zm-.58-.52h0s.1,0,.15.13l.14.24a.22.22,0,0,0,.24.14h0c.07,0,.1,0,.11,0s0,0,0-.1L81,33.16c-.14-.24-.23-.3-.42-.3s-.28.07-.43.3l-.23.36s0,.08,0,.1,0,0,.1,0H80a.24.24,0,0,0,.24-.14l.14-.24C80.43,33.18,80.48,33.14,80.53,33.14Z"
      />
      <path
        className="cls-3"
        d="M82.44,35.21c0-.8.43-1.26,1.36-1.26a1.48,1.48,0,0,1,.53.08c.15,0,.19.09.19.23v.06c0,.15,0,.2-.19.15a1.38,1.38,0,0,0-.52-.09c-.68,0-.91.27-.91.84v.59c0,.61.27.83.95.83a1.59,1.59,0,0,0,.55-.08c.14-.05.18,0,.18.15v.06c0,.13,0,.18-.2.22a1.65,1.65,0,0,1-.56.08c-.94,0-1.38-.4-1.38-1.26Z"
      />
      <path
        className="cls-3"
        d="M83.82,37.08a1.45,1.45,0,0,1-1-.31,1.22,1.22,0,0,1-.34-1v-.6a1.23,1.23,0,0,1,.33-.93,1.39,1.39,0,0,1,1-.34,1.8,1.8,0,0,1,.54.08c.15,0,.18.1.18.24v.06c0,.09,0,.14,0,.16a.16.16,0,0,1-.15,0,1.72,1.72,0,0,0-.52-.08c-.64,0-.91.24-.91.83v.59c0,.6.26.82.95.82a1.46,1.46,0,0,0,.54-.08.19.19,0,0,1,.15,0s0,.07,0,.16v.06c0,.14,0,.19-.19.23A2,2,0,0,1,83.82,37.08Zm0-3.12c-.88,0-1.35.43-1.35,1.25v.6c0,.86.43,1.25,1.37,1.25a2,2,0,0,0,.56-.07c.15,0,.19-.09.19-.22v-.06c0-.08,0-.13,0-.15s-.07,0-.13,0a1.82,1.82,0,0,1-.55.08c-.69,0-1-.24-1-.84v-.59c0-.6.27-.85.92-.85a1.51,1.51,0,0,1,.53.09c.07,0,.11,0,.13,0s0-.07,0-.15v-.06c0-.13,0-.18-.18-.23A1.7,1.7,0,0,0,83.8,34Z"
      />
      <path
        className="cls-3"
        d="M86.59,36.68c0-.15,0-.19.2-.16a3.24,3.24,0,0,0,.89.13c.47,0,.66-.09.66-.35s-.1-.3-.39-.44l-.74-.35c-.39-.19-.57-.37-.57-.79S87,34,87.72,34a2.58,2.58,0,0,1,.76.11c.14,0,.18.09.18.23v.06c0,.15,0,.18-.19.14a2.41,2.41,0,0,0-.76-.11c-.45,0-.62.09-.62.34s.11.3.32.4l.78.35c.41.2.61.38.61.82s-.37.78-1.15.78a3.12,3.12,0,0,1-.86-.11c-.16-.05-.2-.1-.2-.23Z"
      />
      <path
        className="cls-3"
        d="M87.65,37.08a3.15,3.15,0,0,1-.87-.12c-.15,0-.19-.09-.19-.23v0c0-.08,0-.13,0-.15s.08,0,.16,0a3.35,3.35,0,0,0,.89.12c.48,0,.66-.09.66-.34s-.09-.29-.39-.43l-.75-.36c-.37-.18-.57-.36-.57-.79s.35-.78,1.09-.78a2.2,2.2,0,0,1,.76.12c.15,0,.19.09.19.23v.06a.21.21,0,0,1,0,.15.21.21,0,0,1-.16,0,2.23,2.23,0,0,0-.75-.12c-.44,0-.61.1-.61.34a.43.43,0,0,0,.31.39l.78.36c.4.18.61.37.61.82S88.43,37.08,87.65,37.08Zm-1-.56-.06,0s0,.07,0,.14v0c0,.13,0,.18.19.22a3,3,0,0,0,.86.11c.79,0,1.14-.23,1.14-.77s-.21-.63-.6-.81l-.78-.36a.44.44,0,0,1-.33-.4c0-.25.18-.35.63-.35a2.33,2.33,0,0,1,.76.12c.07,0,.11,0,.14,0a.18.18,0,0,0,0-.14v-.06c0-.14,0-.17-.18-.22a2.29,2.29,0,0,0-.76-.11c-.73,0-1.07.24-1.07.76s.19.6.56.78l.74.36c.3.14.4.25.4.44s-.18.35-.67.35a3.48,3.48,0,0,1-.9-.12Z"
      />
      <path
        className="cls-3"
        d="M89.38,35.79v-.56c0-.85.45-1.28,1.34-1.28s1.33.44,1.33,1.28v.56c0,.86-.44,1.28-1.33,1.28S89.38,36.63,89.38,35.79Zm2.21-.56c0-.59-.2-.85-.87-.85s-.88.26-.88.85v.56c0,.59.22.85.88.85s.87-.26.87-.85Zm-1.3-2.08c.15-.22.23-.3.43-.3s.29.06.43.3l.24.36c.07.11,0,.14-.08.14h0a.23.23,0,0,1-.25-.14l-.14-.24c-.1-.17-.2-.17-.29,0l-.14.24c-.06.12-.12.14-.25.14h0c-.13,0-.15,0-.08-.14Zm1.55-.36a.27.27,0,0,1-.26.14h-.06c-.14,0-.16,0-.09-.15l.25-.49a.28.28,0,0,1,.31-.18h.06c.16,0,.19,0,.1.17Z"
      />
      <path
        className="cls-3"
        d="M90.72,37.08c-.91,0-1.34-.41-1.34-1.29v-.56a1.31,1.31,0,0,1,.33-1,1.46,1.46,0,0,1,1-.32c.91,0,1.34.41,1.34,1.29v.56C92.06,36.65,91.61,37.08,90.72,37.08Zm0-3.12a1.41,1.41,0,0,0-1,.31,1.27,1.27,0,0,0-.33,1v.56c0,.87.42,1.27,1.33,1.27a1.38,1.38,0,0,0,1-.31,1.27,1.27,0,0,0,.33-1v-.56C92,34.36,91.62,34,90.72,34Zm0,2.69c-.64,0-.89-.24-.89-.86v-.56c0-.62.24-.86.89-.86s.88.24.88.86v.56C91.6,36.42,91.36,36.65,90.72,36.65Zm0-2.26c-.64,0-.87.22-.87.84v.56c0,.61.24.84.87.84s.87-.22.87-.84v-.56C91.59,34.61,91.35,34.39,90.72,34.39Zm.59-.73h0a.24.24,0,0,1-.26-.15l-.14-.23c-.09-.17-.18-.17-.28,0l-.13.23a.24.24,0,0,1-.26.15h0c-.07,0-.11,0-.12,0s0-.06,0-.11l.23-.36c.14-.22.23-.3.43-.3s.29.06.44.3l.23.36c0,.05,0,.09,0,.11S91.38,33.66,91.31,33.66Zm-.59-.52s.1,0,.15.13l.14.24a.24.24,0,0,0,.25.14h0c.06,0,.1,0,.11,0s0,0,0-.1l-.23-.36c-.15-.24-.23-.3-.43-.3s-.28.07-.42.3l-.23.36s0,.08,0,.1,0,0,.11,0h0a.25.25,0,0,0,.25-.14l.13-.24C90.62,33.18,90.67,33.14,90.72,33.14Zm.86-.2h-.06c-.08,0-.12,0-.13,0a.18.18,0,0,1,0-.13l.26-.49A.28.28,0,0,1,92,32.1h.06c.09,0,.14,0,.15,0s0,.07,0,.15l-.3.5A.31.31,0,0,1,91.58,32.94Zm.41-.83a.28.28,0,0,0-.3.18l-.26.49c0,.07,0,.1,0,.12s0,0,.12,0h.06a.29.29,0,0,0,.26-.15l.3-.5c0-.07.06-.11,0-.13s-.06,0-.14,0Z"
      />
      <path
        className="cls-3"
        d="M93.15,36.82c0,.16,0,.19-.19.19h-.07c-.15,0-.2,0-.2-.19V35.09c0-.76.43-1.14,1.28-1.14s1.26.4,1.26,1.14v1.73c0,.16,0,.19-.19.19H95c-.17,0-.2,0-.2-.19V35.09c0-.49-.19-.71-.8-.71s-.82.23-.82.71Z"
      />
      <path
        className="cls-3"
        d="M95,37H95c-.17,0-.21,0-.21-.2V35.09c0-.51-.21-.7-.79-.7s-.81.19-.81.7v1.73c0,.16,0,.2-.2.2h-.07c-.15,0-.2,0-.2-.2V35.09c0-.76.43-1.15,1.28-1.15a1.36,1.36,0,0,1,1,.3,1.11,1.11,0,0,1,.3.85v1.73C95.24,37,95.21,37,95,37ZM94,34.37c.59,0,.81.2.81.72v1.73c0,.16,0,.18.19.18H95c.16,0,.19,0,.19-.18V35.09a1.08,1.08,0,0,0-.3-.84A1.33,1.33,0,0,0,94,34a1.38,1.38,0,0,0-1,.28,1.09,1.09,0,0,0-.32.85v1.73c0,.16,0,.18.19.18H93c.16,0,.19,0,.19-.18V35.09C93.15,34.57,93.38,34.37,94,34.37Z"
      />
      <path
        className="cls-3"
        d="M98.39,35.08c0,.7-.41,1.06-1.26,1.06a2.94,2.94,0,0,0-.64,0,.18.18,0,0,0-.15.19c0,.08,0,.14.16.17a4.07,4.07,0,0,0,.63,0,2,2,0,0,1,1,.19.7.7,0,0,1,.3.65.82.82,0,0,1-.3.72,1.86,1.86,0,0,1-1,.21,1.92,1.92,0,0,1-1-.21.73.73,0,0,1-.29-.64.71.71,0,0,1,.35-.65.4.4,0,0,1-.25-.4c0-.27.16-.43.49-.48a.85.85,0,0,1-.51-.88V35c0-.66.47-1,1.26-1a1.54,1.54,0,0,1,.63.12l.35-.31c.1-.09.15-.09.25,0l0,0c.1.09.1.14,0,.24l-.27.28a.91.91,0,0,1,.26.68Zm-1.85,1.86a.53.53,0,0,0-.29.5c0,.4.23.5.88.5s.88-.1.88-.51-.22-.45-.88-.45A4,4,0,0,1,96.54,36.94ZM97.93,35c0-.43-.27-.64-.8-.64s-.81.21-.81.64v.08c0,.43.2.65.81.65s.8-.22.8-.65Z"
      />
      <path
        className="cls-3"
        d="M97.13,38.34a1.89,1.89,0,0,1-1-.2.76.76,0,0,1-.29-.65.72.72,0,0,1,.33-.65.41.41,0,0,1-.24-.4q0-.4.48-.48a.86.86,0,0,1-.5-.88V35a1,1,0,0,1,.34-.78,1.45,1.45,0,0,1,.93-.28,1.54,1.54,0,0,1,.63.12l.35-.3c.1-.1.15-.1.25,0l0,0c.06.05.08.08.08.12s0,.07-.08.13l-.27.27a.88.88,0,0,1,.27.68v.08c0,.7-.43,1.06-1.27,1.06a2.81,2.81,0,0,0-.64,0,.18.18,0,0,0-.14.18c0,.08.05.13.15.16a3.66,3.66,0,0,0,.63,0,2,2,0,0,1,1.05.19.68.68,0,0,1,.29.65.8.8,0,0,1-.3.73A2,2,0,0,1,97.13,38.34Zm0-4.38c-.78,0-1.25.39-1.25,1v.08a.86.86,0,0,0,.5.88h0c-.33.05-.49.2-.49.47a.43.43,0,0,0,.25.4h0a.7.7,0,0,0-.34.64.76.76,0,0,0,.28.64,2,2,0,0,0,1,.2,1.9,1.9,0,0,0,1-.2.82.82,0,0,0,.3-.72.68.68,0,0,0-.29-.64,2,2,0,0,0-1-.19,3,3,0,0,1-.64,0,.18.18,0,0,1-.15-.17.18.18,0,0,1,.15-.19,2.74,2.74,0,0,1,.64,0,1.49,1.49,0,0,0,1-.26,1,1,0,0,0,.31-.79V35a.85.85,0,0,0-.27-.67h0l.27-.28c.06,0,.08-.09.08-.12a.16.16,0,0,0-.07-.11l-.05,0c-.09-.09-.14-.09-.24,0l-.35.31h0A1.54,1.54,0,0,0,97.13,34Zm0,4c-.68,0-.88-.12-.88-.51a.49.49,0,0,1,.29-.5h0a4.68,4.68,0,0,0,.59,0c.66,0,.89.07.89.46S97.8,38,97.13,38Zm-.59-1a.5.5,0,0,0-.28.49c0,.38.2.5.87.5s.87-.12.87-.51-.21-.45-.87-.45A4.68,4.68,0,0,1,96.54,37Zm.59-1.21c-.58,0-.81-.19-.81-.66V35c0-.44.26-.65.81-.65s.81.22.81.65v.08C97.94,35.55,97.71,35.74,97.13,35.74Zm0-1.38c-.54,0-.8.21-.8.64v.08c0,.46.23.65.8.65s.8-.19.8-.65V35C97.93,34.58,97.66,34.36,97.13,34.36Z"
      />
      <path
        className="cls-3"
        d="M103.77,33.5c0,.13,0,.17-.17.17h-.36V35.8c0,.85-.45,1.27-1.34,1.27s-1.33-.42-1.33-1.27v-.57A1.12,1.12,0,0,1,101.83,34a1,1,0,0,1,1,.44v-.72H102c-.14,0-.17,0-.17-.17v0c0-.13,0-.17.17-.17h.83V33c0-.17,0-.2.19-.2H103c.15,0,.2,0,.2.2v.33h.36c.13,0,.17,0,.17.17ZM101,35.79c0,.59.2.85.87.85s.88-.26.88-.85v-.56c0-.59-.21-.85-.88-.85s-.87.26-.87.85Z"
      />
      <path
        className="cls-3"
        d="M101.9,37.08a1.41,1.41,0,0,1-1-.32,1.27,1.27,0,0,1-.33-1v-.57a1.31,1.31,0,0,1,.32-1,1.26,1.26,0,0,1,1-.33,1,1,0,0,1,.94.43v-.69H102c-.14,0-.18,0-.18-.18v0c0-.14,0-.18.18-.18h.82V33c0-.17,0-.21.2-.21H103c.15,0,.2,0,.2.21v.32h.36c.13,0,.18,0,.18.18v0c0,.13,0,.18-.18.18h-.36V35.8C103.24,36.65,102.79,37.08,101.9,37.08ZM101.83,34a1.27,1.27,0,0,0-.94.31,1.34,1.34,0,0,0-.31,1v.57a1.24,1.24,0,0,0,.32,1,1.38,1.38,0,0,0,1,.31,1.41,1.41,0,0,0,1-.31,1.26,1.26,0,0,0,.33-1V33.66h.37c.12,0,.17,0,.17-.16v0c0-.12,0-.16-.17-.16h-.37V33c0-.17,0-.19-.19-.19H103c-.16,0-.18,0-.18.19v.34H102c-.14,0-.16,0-.16.16v0c0,.12,0,.16.16.16h.84v.76l0,0A1,1,0,0,0,101.83,34Zm.07,2.69c-.64,0-.88-.23-.88-.86v-.56c0-.62.25-.86.88-.86s.89.24.89.86v.56C102.79,36.41,102.54,36.65,101.9,36.65Zm0-2.26c-.62,0-.87.23-.87.84v.56c0,.62.24.84.87.84s.87-.22.87-.84v-.56C102.77,34.61,102.54,34.39,101.9,34.39Z"
      />
      <path
        className="cls-3"
        d="M103.85,35.79v-.56c0-.85.44-1.28,1.34-1.28.67,0,1.06.23,1.23.66.09,0,.18-.16.18-.48,0-.09,0-.12.14-.12h.1c.11,0,.13,0,.13.12,0,.49-.19.73-.48.81a1.32,1.32,0,0,1,0,.29v.56c0,.86-.44,1.28-1.32,1.28S103.85,36.63,103.85,35.79Zm2.21-.56c0-.59-.21-.85-.87-.85s-.89.26-.89.85v.56c0,.59.23.85.89.85s.87-.26.87-.85Z"
      />
      <path
        className="cls-3"
        d="M105.19,37.08c-.92,0-1.35-.41-1.35-1.29v-.56a1.31,1.31,0,0,1,.34-1,1.42,1.42,0,0,1,1-.32c.66,0,1,.21,1.23.66.12-.05.17-.21.17-.47,0-.1,0-.13.15-.13h.1c.11,0,.14,0,.14.13,0,.44-.16.72-.48.82a2.46,2.46,0,0,1,0,.28v.56A1.16,1.16,0,0,1,105.19,37.08Zm0-3.12a1.39,1.39,0,0,0-1,.31,1.27,1.27,0,0,0-.33,1v.56c0,.87.42,1.27,1.33,1.27a1.4,1.4,0,0,0,1-.31,1.27,1.27,0,0,0,.33-1v-.56a2.48,2.48,0,0,0,0-.29h0q.48-.15.48-.81c0-.09,0-.11-.13-.11h-.1c-.1,0-.13,0-.13.11,0,.27-.06.43-.19.49h0C106.23,34.17,105.85,34,105.19,34Zm0,2.69c-.64,0-.89-.24-.89-.86v-.56c0-.62.24-.86.89-.86s.87.24.87.86v.56C106.06,36.42,105.83,36.65,105.19,36.65Zm0-2.26c-.64,0-.88.22-.88.84v.56c0,.61.25.84.88.84s.86-.22.86-.84v-.56C106.05,34.61,105.82,34.39,105.19,34.39Z"
      />
      <path
        className="cls-3"
        d="M107.62,36.82c0,.16,0,.19-.2.19h-.07c-.15,0-.19,0-.19-.19V35.09c0-.76.43-1.14,1.27-1.14s1.27.4,1.27,1.14v1.73c0,.16,0,.19-.2.19h-.07c-.17,0-.2,0-.2-.19V35.09c0-.49-.18-.71-.8-.71s-.81.23-.81.71Z"
      />
      <path
        className="cls-3"
        d="M109.5,37h-.07c-.17,0-.2,0-.2-.2V35.09c0-.51-.22-.7-.8-.7s-.81.19-.81.7v1.73c0,.16,0,.2-.2.2h-.07c-.15,0-.2,0-.2-.2V35.09c0-.76.43-1.15,1.28-1.15a1.36,1.36,0,0,1,1,.3,1.08,1.08,0,0,1,.3.85v1.73C109.7,37,109.67,37,109.5,37Zm-1.07-2.65c.59,0,.81.2.81.72v1.73c0,.16,0,.18.19.18h.07c.16,0,.19,0,.19-.18V35.09a1.11,1.11,0,0,0-.29-.84,1.36,1.36,0,0,0-1-.29,1.38,1.38,0,0,0-1,.28,1.09,1.09,0,0,0-.32.85v1.73c0,.16,0,.18.19.18h.07c.16,0,.19,0,.19-.18V35.09C107.61,34.57,107.84,34.37,108.43,34.37Z"
      />
      <path
        className="cls-3"
        d="M114.48,35.08c0,.7-.41,1.06-1.25,1.06a3,3,0,0,0-.65,0,.18.18,0,0,0-.15.19c0,.08,0,.14.16.17a4.14,4.14,0,0,0,.64,0,2,2,0,0,1,1,.19.71.71,0,0,1,.29.65.82.82,0,0,1-.3.72,1.84,1.84,0,0,1-1,.21,1.94,1.94,0,0,1-1.06-.21.75.75,0,0,1-.28-.64.71.71,0,0,1,.34-.65.4.4,0,0,1-.25-.4c0-.27.16-.43.49-.48a.85.85,0,0,1-.51-.88V35c0-.66.47-1,1.27-1a1.52,1.52,0,0,1,.62.12l.35-.31c.1-.09.15-.09.25,0l0,0c.1.09.1.14,0,.24l-.27.28a.91.91,0,0,1,.26.68Zm-1.85,1.86a.53.53,0,0,0-.29.5c0,.4.23.5.89.5s.87-.1.87-.51-.22-.45-.87-.45A4,4,0,0,1,112.63,36.94ZM114,35c0-.43-.26-.64-.79-.64s-.81.21-.81.64v.08c0,.43.19.65.81.65s.79-.22.79-.65Z"
      />
      <path
        className="cls-3"
        d="M113.23,38.34a1.93,1.93,0,0,1-1.06-.2.76.76,0,0,1-.29-.65.71.71,0,0,1,.34-.65.4.4,0,0,1-.25-.4q0-.4.48-.48a.86.86,0,0,1-.5-.88V35a1,1,0,0,1,.34-.78,1.46,1.46,0,0,1,.94-.28,1.52,1.52,0,0,1,.62.12l.35-.3c.1-.1.15-.1.25,0l0,0c.06.05.08.08.08.12s0,.07-.08.13l-.26.27a.91.91,0,0,1,.26.68v.08c0,.7-.43,1.06-1.26,1.06a2.85,2.85,0,0,0-.65,0,.18.18,0,0,0-.14.18c0,.08,0,.13.15.16a3.72,3.72,0,0,0,.64,0,2,2,0,0,1,1,.19.69.69,0,0,1,.3.65.81.81,0,0,1-.31.73A2,2,0,0,1,113.23,38.34Zm0-4.38c-.79,0-1.26.39-1.26,1v.08a.86.86,0,0,0,.5.88h0c-.33.05-.48.2-.48.47a.42.42,0,0,0,.24.4h0a.7.7,0,0,0-.34.64.74.74,0,0,0,.29.64,2.8,2.8,0,0,0,2.08,0,.81.81,0,0,0,.29-.72.68.68,0,0,0-.29-.64,1.92,1.92,0,0,0-1-.19,2.88,2.88,0,0,1-.64,0c-.11,0-.16-.09-.16-.17a.18.18,0,0,1,.15-.19,2.79,2.79,0,0,1,.65,0,1.48,1.48,0,0,0,.94-.26,1,1,0,0,0,.31-.79V35a.85.85,0,0,0-.27-.67h0l.28-.28a.19.19,0,0,0,.07-.12.16.16,0,0,0-.07-.11l0,0c-.1-.1-.14-.09-.25,0l-.35.31h0A1.52,1.52,0,0,0,113.23,34Zm0,4c-.69,0-.89-.12-.89-.51a.49.49,0,0,1,.29-.5h0a4.75,4.75,0,0,0,.6,0c.65,0,.88.07.88.46S113.81,38,113.23,38Zm-.6-1a.5.5,0,0,0-.28.49c0,.38.2.5.88.5s.86-.12.86-.51-.21-.45-.86-.45A4.75,4.75,0,0,1,112.63,37Zm.6-1.21c-.58,0-.82-.19-.82-.66V35c0-.44.27-.65.82-.65s.8.22.8.65v.08C114,35.55,113.8,35.74,113.23,35.74Zm0-1.38c-.55,0-.81.21-.81.64v.08c0,.46.23.65.81.65s.79-.19.79-.65V35C114,34.58,113.75,34.36,113.23,34.36Z"
      />
      <path
        className="cls-3"
        d="M115.7,33.07a.29.29,0,0,1-.29.3.3.3,0,0,1-.31-.3.31.31,0,0,1,.31-.3A.3.3,0,0,1,115.7,33.07Zm-.52,1.13c0-.15,0-.19.19-.19h.07c.15,0,.19,0,.19.19v2.62c0,.16,0,.19-.19.19h-.07c-.17,0-.19,0-.19-.19Z"
      />
      <path
        className="cls-3"
        d="M115.44,37h-.07c-.17,0-.2,0-.2-.2V34.2c0-.15,0-.2.2-.2h.07c.15,0,.2,0,.2.2v2.62C115.64,37,115.59,37,115.44,37Zm-.07-3c-.16,0-.19,0-.19.18v2.62c0,.16,0,.18.19.18h.07c.14,0,.18,0,.18-.18V34.2c0-.14,0-.18-.18-.18Zm0-.65a.3.3,0,1,1,0-.6.3.3,0,1,1,0,.6Zm0-.59a.29.29,0,1,0,0,.58.29.29,0,0,0,0-.58Z"
      />
      <path
        className="cls-3"
        d="M118.7,36.11c0,.68-.39,1-1.27,1-.7,0-1.14-.28-1.14-.91s.41-.89,1.24-.89h.72V34.9c0-.41-.29-.55-.8-.55a3.06,3.06,0,0,0-.67.07c-.15,0-.2,0-.2-.15v-.05c0-.14,0-.18.19-.21a3.37,3.37,0,0,1,.66-.06c.85,0,1.27.32,1.27.95Zm-.45-.48h-.72c-.54,0-.79.15-.79.53s.23.52.69.52.82-.13.82-.59Zm-.72-2c-.11,0-.12,0-.14-.12s.09-.24.27-.43a.23.23,0,0,0,.08-.14c0-.11,0-.16-.11-.16a.58.58,0,0,0-.27,0c-.07,0-.12,0-.16-.06l0-.05c0-.09,0-.13.09-.16a.85.85,0,0,1,.36-.07.4.4,0,0,1,.43.45c0,.26-.36.37-.37.57a.14.14,0,0,1-.12.12Z"
      />
      <path
        className="cls-3"
        d="M117.43,37.08c-.75,0-1.15-.32-1.15-.92s.38-.9,1.25-.9h.71V34.9c0-.38-.24-.54-.79-.54a3.26,3.26,0,0,0-.67.06c-.08,0-.13,0-.16,0s0-.07,0-.14v-.05c0-.14,0-.18.19-.22a3.23,3.23,0,0,1,.66-.06c.85,0,1.28.33,1.28,1v1.21C118.71,36.78,118.31,37.08,117.43,37.08Zm.1-1.8c-.86,0-1.24.27-1.24.88s.39.9,1.14.9a1.62,1.62,0,0,0,1-.22.83.83,0,0,0,.31-.73V34.9a.84.84,0,0,0-.32-.71,1.64,1.64,0,0,0-.95-.23,3.23,3.23,0,0,0-.66.06c-.15,0-.18.06-.18.2v.05c0,.07,0,.11,0,.13s.07,0,.15,0a3.13,3.13,0,0,1,.67-.07c.56,0,.8.17.8.56v.38Zm-.1,1.4c-.47,0-.69-.17-.69-.52s.24-.54.79-.54h.72v.47C118.25,36.58,117.94,36.68,117.43,36.68Zm.1-1c-.55,0-.78.15-.78.52s.22.51.68.51.81-.16.81-.58v-.45Zm0-2c-.12,0-.13,0-.15-.12s.06-.22.19-.36l.09-.09a.19.19,0,0,0,.07-.13c0-.11,0-.15-.1-.16h0a.53.53,0,0,0-.23.06c-.08,0-.13,0-.18-.07l0-.05c0-.1,0-.13.09-.16a.85.85,0,0,1,.36-.07.48.48,0,0,1,.32.11.45.45,0,0,1,.11.34.51.51,0,0,1-.2.34.4.4,0,0,0-.17.23.13.13,0,0,1-.12.12Zm.07-.87h0c.06,0,.12,0,.12.17a.23.23,0,0,1-.08.14l-.09.09c-.13.13-.2.2-.19.34s0,.11.14.11h0a.13.13,0,0,0,.11-.11.42.42,0,0,1,.17-.24A.47.47,0,0,0,118,33a.44.44,0,0,0-.11-.33.43.43,0,0,0-.31-.11.85.85,0,0,0-.36.07c-.07,0-.11.06-.08.15l0,0c0,.09.09.09.16.07A.53.53,0,0,1,117.6,32.81Z"
      />
      <path
        className="cls-3"
        d="M119.81,36.82c0,.16,0,.19-.2.19h-.07c-.15,0-.19,0-.19-.19V35.09c0-.76.43-1.14,1.27-1.14s1.27.4,1.27,1.14v1.73c0,.16,0,.19-.2.19h-.07c-.17,0-.2,0-.2-.19V35.09c0-.49-.18-.71-.8-.71s-.81.23-.81.71Z"
      />
      <path
        className="cls-3"
        d="M121.69,37h-.07c-.17,0-.2,0-.2-.2V35.09c0-.51-.22-.7-.8-.7s-.81.19-.81.7v1.73c0,.16,0,.2-.2.2h-.07c-.15,0-.2,0-.2-.2V35.09c0-.76.43-1.15,1.28-1.15a1.36,1.36,0,0,1,1,.3,1.08,1.08,0,0,1,.3.85v1.73C121.89,37,121.86,37,121.69,37Zm-1.07-2.65c.59,0,.81.2.81.72v1.73c0,.16,0,.18.19.18h.07c.16,0,.19,0,.19-.18V35.09a1.11,1.11,0,0,0-.29-.84,1.36,1.36,0,0,0-1-.29,1.38,1.38,0,0,0-1,.28,1.09,1.09,0,0,0-.32.85v1.73c0,.16.05.18.19.18h.07c.16,0,.19,0,.19-.18V35.09C119.8,34.57,120,34.37,120.62,34.37Z"
      />
      <path
        className="cls-3"
        d="M124.28,33c0-.17,0-.2.2-.2h.07c.16,0,.19,0,.19.2v1.41a1.07,1.07,0,0,1,1-.41c.74,0,1.12.35,1.12,1.07v1.8c0,.16,0,.19-.19.19h-.08c-.16,0-.19,0-.19-.19V35.07c0-.48-.22-.69-.78-.69s-.84.23-.84.79v1.65c0,.16,0,.19-.19.19h-.07c-.16,0-.2,0-.2-.19Z"
      />
      <path
        className="cls-3"
        d="M126.63,37h-.08c-.16,0-.2,0-.2-.2V35.07c0-.49-.22-.68-.77-.68s-.83.23-.83.78v1.65c0,.16,0,.2-.2.2h-.07c-.15,0-.2,0-.2-.2V33c0-.18,0-.21.2-.21h.07c.16,0,.2,0,.2.21v1.39a1.08,1.08,0,0,1,1-.4c.75,0,1.13.36,1.13,1.08v1.8C126.83,37,126.79,37,126.63,37Zm-1-2.65c.56,0,.79.21.79.7v1.75c0,.16,0,.18.18.18h.08c.16,0,.18,0,.18-.18V35c0-.71-.37-1.06-1.11-1.06a1.07,1.07,0,0,0-1,.41h0V33c0-.16,0-.19-.18-.19h-.07c-.15,0-.19,0-.19.19v3.87c0,.16,0,.18.19.18h.07c.15,0,.18,0,.18-.18V35.17C124.73,34.61,125,34.37,125.58,34.37Z"
      />
      <path
        className="cls-3"
        d="M127.47,35.79v-.56c0-.85.44-1.28,1.34-1.28a1.17,1.17,0,0,1,1.23.66c.09,0,.18-.16.18-.48,0-.09,0-.12.14-.12h.1c.11,0,.13,0,.13.12,0,.49-.2.73-.48.81a1.32,1.32,0,0,1,0,.29v.56c0,.86-.44,1.28-1.32,1.28S127.47,36.63,127.47,35.79Zm2.21-.56c0-.59-.21-.85-.87-.85s-.89.26-.89.85v.56c0,.59.22.85.89.85s.87-.26.87-.85Z"
      />
      <path
        className="cls-3"
        d="M128.81,37.08c-.92,0-1.35-.41-1.35-1.29v-.56a1.31,1.31,0,0,1,.34-1,1.42,1.42,0,0,1,1-.32c.66,0,1.05.21,1.23.66.12-.05.17-.21.17-.47,0-.1,0-.13.15-.13h.1c.11,0,.14,0,.14.13,0,.44-.16.72-.48.82a2.46,2.46,0,0,1,0,.28v.56A1.16,1.16,0,0,1,128.81,37.08Zm0-3.12a1.39,1.39,0,0,0-1,.31,1.27,1.27,0,0,0-.33,1v.56c0,.87.42,1.27,1.33,1.27a1.4,1.4,0,0,0,1-.31,1.27,1.27,0,0,0,.33-1v-.56a2.64,2.64,0,0,0,0-.29h0c.32-.1.47-.37.47-.81,0-.09,0-.11-.12-.11h-.1c-.1,0-.13,0-.13.11,0,.27-.06.43-.19.49h0C129.85,34.17,129.47,34,128.81,34Zm0,2.69c-.64,0-.89-.24-.89-.86v-.56c0-.62.24-.86.89-.86s.87.24.87.86v.56C129.68,36.42,129.45,36.65,128.81,36.65Zm0-2.26c-.64,0-.88.22-.88.84v.56c0,.61.25.84.88.84s.86-.22.86-.84v-.56C129.67,34.61,129.44,34.39,128.81,34.39Z"
      />
      <path
        className="cls-3"
        d="M131.24,36.82c0,.16,0,.19-.2.19H131c-.15,0-.19,0-.19-.19V35.09c0-.76.42-1.14,1.27-1.14s1.27.4,1.27,1.14v1.73c0,.16,0,.19-.2.19h-.07c-.17,0-.2,0-.2-.19V35.09c0-.49-.18-.71-.8-.71s-.81.23-.81.71Z"
      />
      <path
        className="cls-3"
        d="M133.12,37h-.07c-.17,0-.2,0-.2-.2V35.09c0-.51-.22-.7-.8-.7s-.81.19-.81.7v1.73c0,.16,0,.2-.2.2H131c-.15,0-.2,0-.2-.2V35.09c0-.76.43-1.15,1.28-1.15a1.36,1.36,0,0,1,1,.3,1.08,1.08,0,0,1,.3.85v1.73C133.32,37,133.29,37,133.12,37Zm-1.07-2.65c.59,0,.81.2.81.72v1.73c0,.16,0,.18.19.18h.07c.16,0,.19,0,.19-.18V35.09a1.11,1.11,0,0,0-.29-.84,1.36,1.36,0,0,0-1-.29,1.38,1.38,0,0,0-1,.28,1.09,1.09,0,0,0-.32.85v1.73c0,.16.05.18.19.18H131c.16,0,.19,0,.19-.18V35.09C131.23,34.57,131.46,34.37,132.05,34.37Z"
      />
    </svg>
  );
}

export function CopyIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-copy"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
      <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
    </svg>
  );
}

export function CheckIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-check"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 12l5 5l10 -10" />
    </svg>
  );
}

export function KingCrownIco({ width = 24, height = 24, style }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      style={{ enableBackground: 'new 0 0 99 68', ...style }}
      viewBox="0 0 99 68"
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n    .stking-0{fill:#FBAE4F;}\n    .stking-1{fill:#DB8528;}\n    .stking-2{fill:#FFFFFF;}\n    .stking-3{fill:#FCC368;}\n    .stking-4{fill:#FFCF79;}\n  ',
        }}
      />
      <g>
        <path
          className="stking-0"
          d="M75.66,35.3c0,0-0.25-10-1.19-14.3c-2.98,1.19-14.15,8.94-14.15,8.94S58.22,18.32,49.13,9.38
c-9.09,8.94-11.17,20.56-11.17,20.56S26.78,22.19,23.8,21c-0.94,4.3-1.19,14.3-1.19,14.3s-10.43-6.7-16.09-4.32
c6.56,5.66,14.75,33.82,14.75,33.82s6.85,3.13,27.86,3.13C70.14,67.93,77,64.8,77,64.8s8.19-28.16,14.75-33.82
C86.09,28.6,75.66,35.3,75.66,35.3z"
        />
        <g>
          <path
            className="stking-0"
            d="M9.11,29.65c0.01,2.33-1.86,4.23-4.19,4.24c-2.33,0.01-4.23-1.86-4.24-4.19c-0.01-2.33,1.86-4.23,4.19-4.24
  C7.2,25.45,9.1,27.32,9.11,29.65z"
          />
          <path
            className="stking-1"
            d="M5.98,32.22c-2.33,0.01-4.23-1.86-4.24-4.19c0-0.49,0.09-0.95,0.24-1.39c-0.81,0.77-1.31,1.86-1.31,3.06
  c0.01,2.33,1.91,4.21,4.24,4.19c1.84-0.01,3.38-1.21,3.95-2.85C8.11,31.76,7.1,32.21,5.98,32.22z"
          />
          <path
            className="stking-2"
            d="M7.68,27.11c-0.17-0.28-0.44-0.49-0.73-0.65c-0.61-0.36-1.31-0.55-2.01-0.57c-0.29-0.01-0.62,0.04-0.79,0.28
  c-0.18,0.25-0.09,0.62,0.12,0.85c0.21,0.23,0.51,0.34,0.81,0.45c0.46,0.17,0.92,0.34,1.38,0.51c0.23,0.08,0.46,0.17,0.7,0.17
  c0.24,0,0.5-0.11,0.61-0.32C7.88,27.6,7.81,27.32,7.68,27.11z"
          />
        </g>
        <g>
          <path
            className="stking-0"
            d="M98.03,29.65c0.01,2.33-1.86,4.23-4.19,4.24c-2.33,0.01-4.23-1.86-4.24-4.19c-0.01-2.33,1.86-4.23,4.19-4.24
  C96.12,25.45,98.02,27.32,98.03,29.65z"
          />
          <path
            className="stking-1"
            d="M94.9,32.22c-2.33,0.01-4.23-1.86-4.24-4.19c0-0.49,0.09-0.95,0.24-1.39c-0.81,0.77-1.31,1.86-1.31,3.06
  c0.01,2.33,1.91,4.21,4.24,4.19c1.84-0.01,3.38-1.21,3.95-2.85C97.04,31.76,96.03,32.21,94.9,32.22z"
          />
          <path
            className="stking-2"
            d="M96.6,27.11c-0.17-0.28-0.44-0.49-0.73-0.65c-0.61-0.36-1.31-0.55-2.01-0.57c-0.29-0.01-0.62,0.04-0.79,0.28
  c-0.18,0.25-0.09,0.62,0.12,0.85c0.21,0.23,0.51,0.34,0.81,0.45c0.46,0.17,0.92,0.34,1.38,0.51c0.23,0.08,0.46,0.17,0.7,0.17
  c0.24,0,0.5-0.11,0.61-0.32C96.8,27.6,96.73,27.32,96.6,27.11z"
          />
        </g>
        <g>
          <path
            className="stking-0"
            d="M27.96,17.9c0.01,2.33-1.86,4.23-4.19,4.24c-2.33,0.01-4.23-1.86-4.24-4.19c-0.01-2.33,1.86-4.23,4.19-4.24
  C26.05,13.69,27.95,15.57,27.96,17.9z"
          />
          <path
            className="stking-1"
            d="M24.83,20.47c-2.33,0.01-4.23-1.86-4.24-4.19c0-0.49,0.09-0.95,0.24-1.39c-0.81,0.77-1.31,1.86-1.31,3.06
  c0.01,2.33,1.91,4.21,4.24,4.19c1.84-0.01,3.38-1.21,3.95-2.85C26.96,20.01,25.95,20.46,24.83,20.47z"
          />
          <path
            className="stking-2"
            d="M26.53,15.36c-0.17-0.28-0.44-0.49-0.73-0.65c-0.61-0.36-1.31-0.55-2.01-0.57c-0.29-0.01-0.62,0.04-0.79,0.27
  c-0.18,0.25-0.09,0.62,0.12,0.85c0.21,0.23,0.51,0.34,0.81,0.45c0.46,0.17,0.92,0.34,1.38,0.51c0.23,0.08,0.46,0.17,0.7,0.17
  c0.24,0,0.5-0.11,0.61-0.32C26.73,15.85,26.66,15.57,26.53,15.36z"
          />
        </g>
        <g>
          <path
            className="stking-0"
            d="M79.5,17.9c0.01,2.33-1.86,4.23-4.19,4.24c-2.33,0.01-4.23-1.86-4.24-4.19c-0.01-2.33,1.86-4.23,4.19-4.24
  C77.59,13.69,79.49,15.57,79.5,17.9z"
          />
          <path
            className="stking-1"
            d="M76.37,20.47c-2.33,0.01-4.23-1.86-4.24-4.19c0-0.49,0.09-0.95,0.24-1.39c-0.81,0.77-1.31,1.86-1.31,3.06
  c0.01,2.33,1.91,4.21,4.24,4.19c1.84-0.01,3.38-1.21,3.95-2.85C78.51,20.01,77.5,20.46,76.37,20.47z"
          />
          <path
            className="stking-2"
            d="M78.07,15.36c-0.17-0.28-0.44-0.49-0.73-0.65c-0.61-0.36-1.31-0.55-2.01-0.57c-0.29-0.01-0.62,0.04-0.79,0.27
  c-0.18,0.25-0.09,0.62,0.12,0.85c0.21,0.23,0.51,0.34,0.81,0.45c0.46,0.17,0.92,0.34,1.38,0.51c0.23,0.08,0.46,0.17,0.7,0.17
  c0.24,0,0.5-0.11,0.61-0.32C78.27,15.85,78.2,15.57,78.07,15.36z"
          />
        </g>
        <g>
          <path
            className="stking-0"
            d="M54.74,6.26c0.02,3.1-2.48,5.62-5.57,5.64c-3.1,0.02-5.62-2.48-5.64-5.57c-0.02-3.1,2.48-5.62,5.57-5.64
  C52.2,0.67,54.72,3.16,54.74,6.26z"
          />
          <path
            className="stking-1"
            d="M50.58,9.67c-3.1,0.02-5.62-2.48-5.64-5.57c0-0.65,0.13-1.26,0.33-1.85c-1.07,1.03-1.75,2.47-1.74,4.07
  c0.02,3.1,2.54,5.59,5.64,5.57c2.45-0.01,4.49-1.6,5.25-3.79C53.42,9.06,52.07,9.66,50.58,9.67z"
          />
          <path
            className="stking-2"
            d="M52.83,2.88c-0.23-0.37-0.59-0.65-0.97-0.87c-0.81-0.47-1.74-0.73-2.68-0.75c-0.39-0.01-0.83,0.05-1.05,0.37
  c-0.24,0.33-0.12,0.83,0.16,1.13c0.28,0.3,0.68,0.45,1.07,0.6c0.61,0.23,1.22,0.46,1.83,0.68c0.3,0.11,0.61,0.23,0.93,0.22
  c0.32,0,0.66-0.14,0.81-0.43C53.1,3.53,53.01,3.16,52.83,2.88z"
          />
        </g>
        <path
          className="stking-1"
          d="M49.13,59.45c-14.21,0-27.26-7.79-37.53-20.77c5.07,10.31,9.67,26.13,9.67,26.13s6.85,3.13,27.86,3.13
C70.14,67.93,77,64.8,77,64.8s4.6-15.82,9.67-26.13C76.39,51.66,63.34,59.45,49.13,59.45z"
        />
        <path
          className="stking-3"
          d="M20.38,43.84c1.63,3.95,5.16,6.93,9.1,8.58c3.95,1.65,8.3,2.09,12.58,2.05c13.25-0.12,26.24-4.74,37.3-12.03
c0.88-0.58,1.76-1.19,2.35-2.07c0.59-0.87,0.81-2.07,0.28-2.98c-0.9-1.55-3.19-1.38-4.88-0.78c-1.69,0.6-3.64,1.39-5.17,0.46
c-0.95-0.58-1.44-1.67-2.15-2.53c-1.59-1.94-4.5-2.67-6.82-1.7c-1.37,0.57-2.57,1.68-4.05,1.74c-2.11,0.09-3.68-1.97-4.38-3.97
c-0.7-1.99-0.98-4.23-2.34-5.84c-1.04-1.24-2.67-1.96-4.29-1.91c-1.62,0.06-3.19,0.89-4.15,2.2c-0.98,1.34-1.28,3.04-1.84,4.61
c-0.56,1.56-1.58,3.17-3.2,3.54c-1.3,0.3-2.63-0.27-3.76-0.99c-1.12-0.71-2.17-1.59-3.43-2.01c-1.26-0.42-2.86-0.24-3.62,0.85
c-1.08,1.55,0.1,3.89-0.89,5.5c-1.31,2.14-5.1,1.15-6.62,3.15C19.54,40.88,19.83,42.51,20.38,43.84z"
        />
        <path
          className="stking-4"
          d="M49.08,47.05c1.85,1.8,4.65,2.17,7.22,2.11c4.59-0.1,9.14-1.25,13.23-3.34c1.04-0.53,2.08-1.15,2.78-2.09
c0.7-0.94,0.99-2.26,0.45-3.29c-0.58-1.09-1.91-1.56-3.14-1.62c-1.23-0.06-2.46,0.19-3.69,0.12c-2.09-0.12-4-1.16-5.76-2.3
c-1.75-1.14-3.45-2.42-5.43-3.11c-1.97-0.69-4.33-0.7-5.99,0.58c-2.11,1.63-2.38,4.72-2.02,7.36C47,43.51,47.6,45.61,49.08,47.05z"
        />
      </g>
    </svg>
  );
}

export function QueenCrownIco({ width = 24, height = 24, style }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 90 68"
      width={width}
      height={height}
      style={{ enableBackground: 'new 0 0 99 68', ...style }}
      xmlSpace="preserve"
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n    .stqueen-0{fill:#FBAE4F;}\n    .stqueen-1{fill:#FFCF79;}\n    .stqueen-2{fill:#FCD495;}\n    .stqueen-3{opacity:0.5;fill:#FBAE4F;}\n    .stqueen-4{fill:#DB8528;}\n    .stqueen-5{fill:#CC741D;}\n    .stqueen-6{fill:#FFDEA9;}\n    .stqueen-7{fill:#FFC46E;}\n  ',
        }}
      />
      <g>
        <path
          className="stqueen-0"
          d="M14.51,48.4v15.34h61.37V48.4c4.27-2.4,8.11-5.64,10.77-9.71c2.08-3.19,3.86-8.31,0.38-11.21
c-1.85-1.54-4.58-1.64-6.85-1.49c-1.45,0.1-2.89,0.33-4.33,0.6c-0.39,0.02-1.4,0.18-2.68,0.4c0.32-1.77,0.44-3.56,0.31-5.35
c-0.31-4.21-2.91-7.16-7.22-7.59c-0.92-0.09-5.41-0.43-10.11,0.2c0.7-1.04,1.4-1.96,1.95-2.72c1.51-2.08-3.99-2.78-5.28-4.07
c-3.52-3.51-4.24-6.28-7.58-6.31v0c-0.01,0-0.02,0-0.03,0c-0.01,0-0.02,0-0.03,0v0c-3.34,0.03-4.06,2.8-7.58,6.31
c-1.29,1.29-6.79,1.99-5.28,4.07c0.55,0.76,1.25,1.68,1.96,2.72c-4.71-0.62-9.19-0.29-10.12-0.2c-4.32,0.43-6.91,3.38-7.22,7.59
c-0.13,1.78-0.01,3.57,0.31,5.35c-1.29-0.22-2.29-0.38-2.68-0.4c-1.44-0.28-2.88-0.51-4.33-0.6c-2.28-0.15-5-0.05-6.85,1.49
c-3.48,2.9-1.7,8.03,0.38,11.21C6.41,42.75,10.25,46,14.51,48.4z M68.79,38.22c1.18-2.03,2.25-4.23,3.08-6.51
c12.25-2.61,7.04,9.66-4.81,16.08h-6.38C63.83,45.09,66.34,42.47,68.79,38.22z M53.11,20.58c0.18-0.77,0.45-1.51,0.75-2.23
c0.03-0.01,0.06,0,0.09-0.01c11.04-2.9,7.92,16.54-2.11,29.45h-3.3C49.06,41.66,50.18,32.92,53.11,20.58z M36.44,18.34
c0.03,0.01,0.06,0,0.1,0.01c0.3,0.72,0.57,1.46,0.75,2.23c2.91,12.38,4.03,21.11,4.54,27.21h-3.28
C28.52,34.87,25.4,15.44,36.44,18.34z M18.53,31.71c0.83,2.28,1.9,4.48,3.08,6.51c2.46,4.24,4.96,6.86,8.11,9.56h-6.38
C11.49,41.37,6.28,29.1,18.53,31.71z"
        />
        <g>
          <path
            className="stqueen-1"
            d="M67.89,61.29H22.51c-2.98,0-5.39-2.14-5.39-4.79v-1.86c0-2.65,2.41-4.79,5.39-4.79h45.37
  c2.98,0,5.39,2.14,5.39,4.79v1.86C73.28,59.15,70.86,61.29,67.89,61.29z"
          />
          <path
            className="stqueen-2"
            d="M58.14,16.07c24.28-4.98,6.99,24.72,0.71,28.91C56.45,46.58,74.95,16.25,58.14,16.07z"
          />
          <path
            className="stqueen-2"
            d="M76.38,28.53c19.75-0.6-8.27,21.88-0.98,17.79C86.36,40.16,94.7,24.17,76.38,28.53z"
          />
          <path
            className="stqueen-2"
            d="M32.52,16.07c-24.28-4.98-6.99,24.72-0.71,28.91C34.21,46.58,15.71,16.25,32.52,16.07z"
          />
          <path
            className="stqueen-2"
            d="M14.29,28.53c-19.75-0.6,8.27,21.88,0.98,17.79C4.3,40.16-4.03,24.17,14.29,28.53z"
          />
          <path
            className="stqueen-1"
            d="M35.7,10.6c-0.31,0.58-0.2,1.31,0.1,1.9c0.29,0.59,0.75,1.08,1.16,1.6c3.28,4.08,3.94,9.58,5.48,14.58
  c0.34,1.09,0.95,2.35,2.08,2.45c0.76,0.07,1.46-0.46,1.85-1.11c0.39-0.65,0.53-1.42,0.69-2.16c1.09-5.03,3.44-9.77,6.79-13.68
  c0.89-1.04,3.09-2.59,1.74-3.56c-1.35-0.96-3.74,0.24-5.15-0.85c-0.98-0.76-1.5-1.96-2.14-3.02c-0.64-1.07-1.57-2.12-2.81-2.22
  c-1.3-0.11-2.43,0.87-3.26,1.88c-0.83,1.01-1.62,2.16-2.83,2.64c-0.64,0.25-1.34,0.29-2.01,0.45C36.71,9.67,36.01,9.99,35.7,10.6z
  "
          />
        </g>
        <path
          className="stqueen-3"
          d="M75.89,40.69c-2.08,2.51-5.13,5.09-8.83,7.09h-6.38c2.62-2.24,4.79-4.45,6.86-7.55
c-3.41,1.97-7.58,2.68-10.45-0.97c-1.41,2.95-3.17,5.88-5.23,8.53h-3.3c0.15-1.77,0.36-3.79,0.64-6.03
c-2.98,0.02-6.09-1.24-8.48-3.56c0.55,3.74,0.9,6.93,1.12,9.59h-3.28c-1.94-2.5-3.62-5.25-4.99-8.03
c-4.32,5.14-7.65,0.67-11.97-1.56c0.01,0.01,0.01,0.02,0.02,0.03c2.46,4.24,4.96,6.86,8.11,9.56h-6.38
c-3.85-2.08-6.98-4.78-9.05-7.39c-4.52,1.96-8.07,0.76-10.65-1.89c0.04,0.06,0.07,0.12,0.11,0.18c2.66,4.07,6.5,7.31,10.77,9.71
v15.34h61.37V48.4c2.56-1.44,4.96-3.2,7.06-5.24C80.59,43.47,78.38,42.01,75.89,40.69z"
        />
        <g>
          <path
            className="stqueen-4"
            d="M46.45,20.41c0.92-1.82,2.08-4.45,2.5-6.8c0.53-2.93-0.96-6.26-3.74-6.26s-4.25,3.3-3.77,6.15
  c0.44,2.61,1.82,5.58,2.79,7.43C44.78,22.01,45.76,21.79,46.45,20.41z"
          />
          <path
            className="stqueen-0"
            d="M46.12,18.8c0.67-1.4,1.52-3.41,1.83-5.21c0.39-2.25-0.7-4.8-2.75-4.8c-2.05,0-3.12,2.53-2.77,4.72
  c0.32,2,1.34,4.28,2.05,5.69C44.89,20.03,45.61,19.85,46.12,18.8z"
          />
          <path
            className="stqueen-5"
            d="M45.2,7.36C45.2,7.36,45.2,7.36,45.2,7.36L45.2,21.6c0.43-0.05,0.88-0.45,1.25-1.18
  c0.92-1.82,2.08-4.45,2.5-6.8C49.48,10.69,47.99,7.36,45.2,7.36z"
          />
          <path
            className="stqueen-6"
            d="M45.2,8.79C45.2,8.79,45.2,8.79,45.2,8.79l0,10.9c0.31-0.04,0.65-0.33,0.92-0.89
  c0.67-1.4,1.52-3.41,1.83-5.21C48.34,11.34,47.25,8.79,45.2,8.79z"
          />
        </g>
        <g>
          <path
            className="stqueen-4"
            d="M45.89,31.06c0.51-1.01,1.15-2.46,1.38-3.76c0.29-1.62-0.53-3.46-2.07-3.46c-1.54,0-2.35,1.82-2.09,3.4
  c0.24,1.44,1.01,3.09,1.54,4.11C44.97,31.95,45.51,31.82,45.89,31.06z"
          />
          <path
            className="stqueen-0"
            d="M45.71,30.17c0.37-0.77,0.84-1.89,1.01-2.88c0.21-1.24-0.39-2.65-1.52-2.65c-1.13,0-1.72,1.4-1.53,2.61
  c0.18,1.11,0.74,2.37,1.13,3.15C45.03,30.85,45.43,30.75,45.71,30.17z"
          />
          <path
            className="stqueen-5"
            d="M45.2,23.84C45.2,23.84,45.2,23.84,45.2,23.84l0,7.87c0.24-0.03,0.49-0.25,0.69-0.65
  c0.51-1.01,1.15-2.46,1.38-3.76C47.57,25.68,46.74,23.84,45.2,23.84z"
          />
          <path
            className="stqueen-6"
            d="M45.2,24.63L45.2,24.63l0,6.03c0.17-0.02,0.36-0.18,0.51-0.49c0.37-0.77,0.84-1.89,1.01-2.88
  C46.94,26.04,46.33,24.63,45.2,24.63z"
          />
        </g>
        <path
          className="stqueen-1"
          d="M14.3,67H76.1c0.77,0,1.4-0.63,1.4-1.4v-0.9c0-0.77-0.63-1.4-1.4-1.4H14.3c-0.77,0-1.4,0.63-1.4,1.4v0.9
C12.9,66.37,13.53,67,14.3,67z"
        />
        <path
          className="stqueen-7"
          d="M62.54,59.89c1.66-0.05,3.37-0.24,4.81-1.06c1.44-0.82,2.56-2.4,2.41-4.05c-0.18-1.95-2.06-3.39-3.98-3.79
c-1.92-0.41-3.91-0.04-5.86,0.18c-7.02,0.78-14.12-0.41-21.16,0.08c-1.13,0.08-2.28,0.21-3.32,0.67c-1.04,0.46-1.96,1.3-2.25,2.4
c-0.34,1.27,0.23,2.67,1.19,3.58c0.96,0.91,2.24,1.39,3.52,1.7c4.65,1.1,9.5,0.03,14.28-0.04C55.65,59.5,59.09,59.98,62.54,59.89z"
        />
        <path
          className="stqueen-2"
          d="M64.27,56.65c0.45-0.96-0.17-2.15-1.08-2.7c-0.91-0.55-2.02-0.62-3.08-0.67C56,53.07,46.89,55.25,47.63,56.3
c0.76,1.07,2.26,1.21,3.56,1.25c3.24,0.11,6.49,0.22,9.73,0.32C62.18,57.91,63.73,57.79,64.27,56.65z"
        />
      </g>
    </svg>
  );
}

export function MinusIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-minus"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 12l14 0" />
    </svg>
  );
}

export function PlusIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-plus"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 5l0 14" />
      <path d="M5 12l14 0" />
    </svg>
  );
}

export function RotateLeftIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-rotate"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5" />
    </svg>
  );
}

export function RotateRightIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-rotate-clockwise"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5" />
    </svg>
  );
}

export function ArrowVerticalIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-vertical"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8 7l4 -4l4 4" />
      <path d="M8 17l4 4l4 -4" />
      <path d="M12 3l0 18" />
    </svg>
  );
}

export function ArrowHorizonalIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-horizontal"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M7 8l-4 4l4 4" />
      <path d="M17 8l4 4l-4 4" />
      <path d="M3 12l18 0" />
    </svg>
  );
}

export function MaleIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-gender-male"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
      <path d="M19 5l-5.4 5.4" />
      <path d="M19 5h-5" />
      <path d="M19 5v5" />
    </svg>
  );
}

export function PartyIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-confetti"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 5h2" />
      <path d="M5 4v2" />
      <path d="M11.5 4l-.5 2" />
      <path d="M18 5h2" />
      <path d="M19 4v2" />
      <path d="M15 9l-1 1" />
      <path d="M18 13l2 -.5" />
      <path d="M18 19h2" />
      <path d="M19 18v2" />
      <path d="M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39z" />
    </svg>
  );
}

export function FemaleIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-gender-female"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
      <path d="M12 14v7" />
      <path d="M9 18h6" />
    </svg>
  );
}

export function BannerIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-photo"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M15 8h.01" />
      <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z" />
      <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5" />
      <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3" />
    </svg>
  );
}

export function AlbumIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-library-photo"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
      <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
      <path d="M17 7h.01" />
      <path d="M7 13l3.644 -3.644a1.21 1.21 0 0 1 1.712 0l3.644 3.644" />
      <path d="M15 12l1.644 -1.644a1.21 1.21 0 0 1 1.712 0l2.644 2.644" />
    </svg>
  );
}

export function HeartsIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-hearts"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M14.017 18l-2.017 2l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.153 5.784" />
      <path d="M15.99 20l4.197 -4.223a2.81 2.81 0 0 0 0 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.28 .282l-.279 -.283a2.747 2.747 0 0 0 -3.91 -.007a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238z" />
    </svg>
  );
}

export function MusicIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="{1.5}"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-music"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
      <path d="M13 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
      <path d="M9 17v-13h10v13" />
      <path d="M9 8h10" />
    </svg>
  );
}

export function PCIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-device-imac"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12z" />
      <path d="M3 13h18" />
      <path d="M8 21h8" />
      <path d="M10 17l-.5 4" />
      <path d="M14 17l.5 4" />
    </svg>
  );
}

export function MobileIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-device-mobile"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z" />
      <path d="M11 4h2" />
      <path d="M12 17v.01" />
    </svg>
  );
}

export function LocateIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-location"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
    </svg>
  );
}

export function UploadIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-upload"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
      <path d="M7 9l5 -5l5 5" />
      <path d="M12 4l0 12" />
    </svg>
  );
}

export function CloseIco({ width = 24, height = 24, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-circle-x"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z" />
    </svg>
  );
}
